/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AccountSubType {
  Association = "Association",
  Athlete = "Athlete",
  Brand = "Brand",
  Business = "Business",
  ContentCreator = "ContentCreator",
  EventOrganizer = "EventOrganizer",
  FanPage = "FanPage",
  Gym = "Gym",
  Host = "Host",
  League = "League",
  PodcastHost = "PodcastHost",
  Shop = "Shop",
  SocialPage = "SocialPage",
  Team = "Team",
}

export enum AccountType {
  Basic = "Basic",
  Creator = "Creator",
}

export enum AdminOrderBy {
  createdAt = "createdAt",
  firstName = "firstName",
  lastName = "lastName",
}

export enum AdminStoresOrderBy {
  activatedAt = "activatedAt",
  amaVideo = "amaVideo",
  contactRole = "contactRole",
  createdAt = "createdAt",
  email = "email",
  facebookLink = "facebookLink",
  firstName = "firstName",
  followerCount = "followerCount",
  initialAssessment = "initialAssessment",
  instagramLink = "instagramLink",
  lastName = "lastName",
  latestAssessment = "latestAssessment",
  managedByName = "managedByName",
  phoneNumber = "phoneNumber",
  revenue = "revenue",
  socialFollowerCount = "socialFollowerCount",
  socialMediaLink = "socialMediaLink",
  status = "status",
  storeName = "storeName",
  tiktokLink = "tiktokLink",
  totalSales = "totalSales",
  twitterLink = "twitterLink",
}

export enum AffiliateStreamsOrderBy {
  ActiveLinks = "ActiveLinks",
  Clicks = "Clicks",
  Commission = "Commission",
  Revenue = "Revenue",
  Sales = "Sales",
  ScheduleDate = "ScheduleDate",
}

export enum Age {
  Adult = "Adult",
  Youth = "Youth",
}

export enum AgencyListOrderBy {
  createdAt = "createdAt",
  firstName = "firstName",
  lastName = "lastName",
}

export enum AiClipCandidateApprovalSource {
  Manual = "Manual",
  System = "System",
}

export enum AiClipCandidateStatus {
  Accepted = "Accepted",
  NotReviewed = "NotReviewed",
  Rejected = "Rejected",
}

export enum AiClipperSettingType {
  AutoApproval = "AutoApproval",
  PostAutoGeneration = "PostAutoGeneration",
}

export enum AiClipperSourceType {
  Interview = "Interview",
  Post = "Post",
  PpvStream = "PpvStream",
}

/**
 * Bucket size for the AI clipper metrics time series.
 */
export enum AiClipperTimeSeriesGranularity {
  Day = "Day",
  Month = "Month",
  Week = "Week",
  Year = "Year",
}

export enum AmaOrderBy {
  CreatedAt = "CreatedAt",
  Price = "Price",
  StoreName = "StoreName",
}

export enum AmaOrderStatus {
  Accepted = "Accepted",
  Completed = "Completed",
  Declined = "Declined",
  Pending = "Pending",
  Processing = "Processing",
}

export enum AmaRequestOrderBy {
  CreatedAt = "CreatedAt",
  CustomerEmail = "CustomerEmail",
  CustomerFirstName = "CustomerFirstName",
  DateToResponse = "DateToResponse",
  DiscountAmount = "DiscountAmount",
  Id = "Id",
  Instructions = "Instructions",
  OrderStatus = "OrderStatus",
  Price = "Price",
  ReceiverEmail = "ReceiverEmail",
}

export enum AmaRequestOrderByFilter {
  amaId = "amaId",
  createdAt = "createdAt",
  email = "email",
  firstName = "firstName",
  lastName = "lastName",
  name = "name",
  orderStatus = "orderStatus",
}

export enum AmaSalesOrderBy {
  createdAt = "createdAt",
  customerEmail = "customerEmail",
  customerName = "customerName",
  discount = "discount",
  earnings = "earnings",
}

export enum AmaStatus {
  Active = "Active",
  Inactive = "Inactive",
}

export enum AmaType {
  Ama = "Ama",
  Shoutout = "Shoutout",
}

/**
 * price sorts by Order.subtotal
 */
export enum AnyProductSalesOrderBy {
  createdAt = "createdAt",
  customerEmail = "customerEmail",
  customerName = "customerName",
  rawCreatedAt = "rawCreatedAt",
  status = "status",
  subtotal = "subtotal",
  totalStoreRevenues = "totalStoreRevenues",
  type = "type",
}

export enum ArticleOrderBy {
  createdAt = "createdAt",
  status = "status",
  storeName = "storeName",
}

export enum ArticleStatus {
  Active = "Active",
  Disabled = "Disabled",
  Draft = "Draft",
  PendingReview = "PendingReview",
}

export enum ArticleTypes {
  Generated = "Generated",
  Sponsored = "Sponsored",
}

export enum AuctionStatus {
  Finished = "Finished",
  Live = "Live",
  Scheduled = "Scheduled",
}

export enum AudienceAgeRange {
  AGE_13_17 = "AGE_13_17",
  AGE_18_24 = "AGE_18_24",
  AGE_25_34 = "AGE_25_34",
  AGE_35_44 = "AGE_35_44",
  AGE_45_54 = "AGE_45_54",
  AGE_65_PLUS = "AGE_65_PLUS",
}

export enum AudienceEthnicity {
  AFRICAN_AMERICAN = "AFRICAN_AMERICAN",
  ASIAN = "ASIAN",
  HISPANIC = "HISPANIC",
  WHITE = "WHITE",
}

export enum AudienceGender {
  FEMALE = "FEMALE",
  MALE = "MALE",
}

export enum AudienceInterest {
  ACTIVEWEAR = "ACTIVEWEAR",
  ART_AND_DESIGN = "ART_AND_DESIGN",
  BEAUTY_AND_COSMETICS = "BEAUTY_AND_COSMETICS",
  BEER_WINE_AND_SPIRITS = "BEER_WINE_AND_SPIRITS",
  BUSINESS_AND_CAREERS = "BUSINESS_AND_CAREERS",
  CAMERA_AND_PHOTOGRAPHY = "CAMERA_AND_PHOTOGRAPHY",
  CARS_AND_MOTORBIKES = "CARS_AND_MOTORBIKES",
  CLOTHES_SHOES_HANDBAGS_AND_ACCESSORIES = "CLOTHES_SHOES_HANDBAGS_AND_ACCESSORIES",
  COFFEE_TEA_AND_BEVERAGES = "COFFEE_TEA_AND_BEVERAGES",
  ELECTRONICS_AND_COMPUTERS = "ELECTRONICS_AND_COMPUTERS",
  FITNESS_AND_YOGA = "FITNESS_AND_YOGA",
  FRIENDS_FAMILY_AND_RELATIONSHIPS = "FRIENDS_FAMILY_AND_RELATIONSHIPS",
  GAMING = "GAMING",
  HEALTHCARE_AND_MEDICINE = "HEALTHCARE_AND_MEDICINE",
  HEALTHY_LIFESTYLE = "HEALTHY_LIFESTYLE",
  HOME_DECOR_FURNITURE_AND_GARDEN = "HOME_DECOR_FURNITURE_AND_GARDEN",
  JEWELLERY_AND_WATCHES = "JEWELLERY_AND_WATCHES",
  LUXURY_GOODS = "LUXURY_GOODS",
  MUSIC = "MUSIC",
  PETS = "PETS",
  RESTAURANTS_FOOD_AND_GROCERY = "RESTAURANTS_FOOD_AND_GROCERY",
  SHOPPING_AND_RETAIL = "SHOPPING_AND_RETAIL",
  SPORTS = "SPORTS",
  TELEVISION_AND_FILM = "TELEVISION_AND_FILM",
  TOBACCO_AND_SMOKING = "TOBACCO_AND_SMOKING",
  TOYS_CHILDREN_AND_BABY = "TOYS_CHILDREN_AND_BABY",
  TRAVEL_TOURISM_AND_AVIATION = "TRAVEL_TOURISM_AND_AVIATION",
  WEDDING = "WEDDING",
}

export enum AuditLogType {
  CampaignBalance = "CampaignBalance",
  CbTeam = "CbTeam",
  CounterOffer = "CounterOffer",
  DeliverableReview = "DeliverableReview",
  DesignRequest = "DesignRequest",
  Interview = "Interview",
  PromoCode = "PromoCode",
  TicketOrder = "TicketOrder",
  VideoEditRequest = "VideoEditRequest",
}

export enum AutoSocialMediaPackStatus {
  failed = "failed",
  generating = "generating",
  missing = "missing",
  ready = "ready",
}

export enum AutoSocialPackImageStatus {
  completed = "completed",
  failed = "failed",
  inProgress = "inProgress",
}

export enum BannerMediaType {
  image = "image",
  video = "video",
}

export enum BusinessType {
  Company = "Company",
  Government_entity = "Government_entity",
  Individual = "Individual",
  Non_profit = "Non_profit",
}

export enum CBDeliverableItemType {
  CONFIRMATION = "CONFIRMATION",
  COPY = "COPY",
  FILE = "FILE",
  FILES = "FILES",
  LINK = "LINK",
}

export enum CBDeliverableStatus {
  APPROVED = "APPROVED",
  ARCHIVED = "ARCHIVED",
  ON_REVIEW = "ON_REVIEW",
  REJECTED = "REJECTED",
}

export enum CampaignActivityCoveredExpense {
  Flight = "Flight",
  Food = "Food",
  GroundTransportation = "GroundTransportation",
  Hotel = "Hotel",
}

export enum CampaignActivityTargetType {
  SponsoredGuest = "SponsoredGuest",
  SponsoredProduct = "SponsoredProduct",
}

export enum CampaignActivityType {
  Custom = "Custom",
  CustomBrief = "CustomBrief",
  EventMarketing = "EventMarketing",
  InPersonAppearance = "InPersonAppearance",
  Social = "Social",
  SocialBoost = "SocialBoost",
  SocialShare = "SocialShare",
  SponsoredAppearance = "SponsoredAppearance",
  Ugc = "Ugc",
  VirtualAppearance = "VirtualAppearance",
}

export enum CampaignAppearanceType {
  EventAttendance = "EventAttendance",
  MeetAndGreet = "MeetAndGreet",
  OnSiteFilming = "OnSiteFilming",
  Other = "Other",
  Photoshoot = "Photoshoot",
  Signing = "Signing",
  Speaking = "Speaking",
}

export enum CampaignFileKind {
  Contract = "Contract",
  Example = "Example",
}

export enum CampaignMediaType {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
}

export enum CampaignOfferAttention {
  BOTH = "BOTH",
  BRAND = "BRAND",
  TALENT = "TALENT",
}

export enum CampaignOfferGenderFilter {
  NA = "NA",
  female = "female",
  male = "male",
  other = "other",
  preferNotToSay = "preferNotToSay",
}

/**
 * V3
 * PROPOSED - Offers are created but not sent, campaign is not yet paid
 * INVITED - Offer is sent to talent
 * DECLINED - Agency declines offer application
 * APPLIED - Talent applied for campaign (offer)
 * ACCEPTED - Agency accepts (approves) talent's application, acts as IN_PROGRESS
 * EXPIRED - Offer gets expired after application deadline
 * PUBLISHED - All posts are published, Brand needs to complete Deal
 * COMPLETED - Brand approves published artifacts by marking them COMPLETED
 * CANCELLED - Accepted Social Boost deal terminated after a brand dispute (budget refunded, terminal)
 * 
 * V3 CPM payout model (payoutModel = Cpm)
 * PUBLISHED - Posts are live and earning views; the payout is not settled yet (amounts on the offer are the cap)
 * COMPLETED - Payout is settled; the amounts on the offer are the actual settled amounts
 * 
 * V2
 * PROPOSED - Offers are created but not sent, campaign is not yet paid
 * INVITED - Offer is sent to talent
 * APPLIED - Talent applied for campaign (offer)
 * ACCEPTED - Agency accepts (approves) talent's application
 * SCHEDULED - SponsoredAppearance: Talent created stream for Live Appearance
 * DECLINED - Agency declines offer application
 * EXPIRED - Offer gets expired after application deadline
 * SUBMITTED - Talent submitted artifact for Brand to review
 * DELIVERABLES_REJECTED - Brand rejected
 * DELIVERABLES_APPROVED - Talent can publish approved deliverables 
 * PUBLISHED - Talent published artifact
 * COMPLETED - Brand approves published artifacts by marking them COMPLETED
 * 
 * V1
 * PROPOSED - Offers are created but not sent, campaign is not yet paid
 * INVITED - Offer is sent to talent
 * APPLIED - Talent applied for campaign (offer)
 * ACCEPTED - Agency accepts (approves) talent's application
 * SCHEDULED - SponsoredAppearance: Talent created stream for Live Appearance
 * DECLINED - Agency declines offer application
 * EXPIRED - Offer gets expired after application deadline
 * SUBMITTED - Talent published artifacts
 */
export enum CampaignOfferStatus {
  ACCEPTED = "ACCEPTED",
  APPLIED = "APPLIED",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  COUNTER_OFFER_PENDING = "COUNTER_OFFER_PENDING",
  DECLINED = "DECLINED",
  DELIVERABLES_APPROVED = "DELIVERABLES_APPROVED",
  DELIVERABLES_REJECTED = "DELIVERABLES_REJECTED",
  EXPIRED = "EXPIRED",
  INVITED = "INVITED",
  PROPOSED = "PROPOSED",
  PUBLISHED = "PUBLISHED",
  SCHEDULED = "SCHEDULED",
  SUBMITTED = "SUBMITTED",
}

export enum CampaignOffersOrderBy {
  appliedAt = "appliedAt",
  approvedAt = "approvedAt",
  avgVote = "avgVote",
  createdAt = "createdAt",
  createdAtPrioritized = "createdAtPrioritized",
  declinedAt = "declinedAt",
  engagementRate = "engagementRate",
  estimatedInfluencerFee = "estimatedInfluencerFee",
  id = "id",
  name = "name",
  socialFollowing = "socialFollowing",
  socialFollowingLive = "socialFollowingLive",
  status = "status",
  submittedAt = "submittedAt",
}

/**
 * How talent is paid. Flat is a fixed fee ("Paid Collab"); Cpm pays per 1,000 views up to a cap.
 */
export enum CampaignPayoutModel {
  Affiliate = "Affiliate",
  Cpm = "Cpm",
  Flat = "Flat",
  ProductInKind = "ProductInKind",
}

export enum CampaignPermission {
  CampaignBudgetManage = "CampaignBudgetManage",
  CampaignCollabManage = "CampaignCollabManage",
  CampaignCollabView = "CampaignCollabView",
  CampaignInsightsView = "CampaignInsightsView",
  CampaignManage = "CampaignManage",
  CampaignView = "CampaignView",
  ChatSend = "ChatSend",
  ChatView = "ChatView",
  CompanyPreferencesManage = "CompanyPreferencesManage",
  ContentHubEdit = "ContentHubEdit",
  ContentHubView = "ContentHubView",
  DealAdminManage = "DealAdminManage",
  DealManage = "DealManage",
  DealRate = "DealRate",
  DealView = "DealView",
  DeliverableManage = "DeliverableManage",
  DeliverableRate = "DeliverableRate",
  DeliverableView = "DeliverableView",
  FinanceManage = "FinanceManage",
  MentionLabManage = "MentionLabManage",
  MentionLabView = "MentionLabView",
  ReportDownload = "ReportDownload",
  ReportView = "ReportView",
  ResearchCreditUse = "ResearchCreditUse",
  ResearchCreditView = "ResearchCreditView",
  SubscriptionManage = "SubscriptionManage",
  TalentCRMEdit = "TalentCRMEdit",
  TalentCRMView = "TalentCRMView",
  TeamManage = "TeamManage",
}

export enum CampaignSearchType {
  BookMe = "BookMe",
  Custom = "Custom",
  Social = "Social",
  SocialBoost = "SocialBoost",
  SocialShare = "SocialShare",
  SponsoredAppearance = "SponsoredAppearance",
  Ugc = "Ugc",
}

export enum CampaignSmPlatform {
  FB = "FB",
  IG = "IG",
  TT = "TT",
  TW = "TW",
  YT = "YT",
}

export enum CampaignStartMode {
  ASAP = "ASAP",
  SCHEDULED = "SCHEDULED",
}

export enum CampaignStatus {
  COMPLETED = "COMPLETED",
  DECLINED = "DECLINED",
  DELETED = "DELETED",
  DETAIL_FILLED = "DETAIL_FILLED",
  ON_REVIEW = "ON_REVIEW",
  PAID_AND_ACTIVE = "PAID_AND_ACTIVE",
  PAID_AND_BUDGET_FULFILLED = "PAID_AND_BUDGET_FULFILLED",
}

export enum CampaignTaskType {
  APPEARANCE = "APPEARANCE",
  CONTENT = "CONTENT",
  FB_SHARE = "FB_SHARE",
  FINAL_CONTENT = "FINAL_CONTENT",
  IG_LIVE = "IG_LIVE",
  IG_POST = "IG_POST",
  IG_REEL = "IG_REEL",
  IG_SHARE = "IG_SHARE",
  IG_STORY = "IG_STORY",
  LIVE_APPEARANCE = "LIVE_APPEARANCE",
  RECORDED_APPEARANCE = "RECORDED_APPEARANCE",
  TT_LIVE = "TT_LIVE",
  TT_SHARE = "TT_SHARE",
  TT_STORY = "TT_STORY",
  TT_VIDEO = "TT_VIDEO",
  TW_LIVE = "TW_LIVE",
  TW_SHARE = "TW_SHARE",
  TW_TWEET = "TW_TWEET",
  TW_VIDEO = "TW_VIDEO",
  UGC = "UGC",
  YT_SHARE = "YT_SHARE",
}

export enum CampaignType {
  BookMe = "BookMe",
  Custom = "Custom",
  DirectBooking = "DirectBooking",
  EventMarketing = "EventMarketing",
  Social = "Social",
  SocialBoost = "SocialBoost",
  SocialShare = "SocialShare",
  SponsoredAppearance = "SponsoredAppearance",
  Ugc = "Ugc",
}

export enum CampaignUsageRightsScope {
  AllOtherMedia = "AllOtherMedia",
  PaidMedia = "PaidMedia",
  SocialRepost = "SocialRepost",
  Website = "Website",
  Whitelisting = "Whitelisting",
}

export enum CampaignsOrderBy {
  budget = "budget",
  createdAt = "createdAt",
  id = "id",
  name = "name",
  status = "status",
  type = "type",
}

export enum CbApplicationQuestionType {
  Pitch = "Pitch",
  Regular = "Regular",
}

/**
 * Kind of account balance ledger movement
 */
export enum CbBalanceTransactionType {
  AdminAdjust = "AdminAdjust",
  CampaignLaunch = "CampaignLaunch",
  CampaignRefund = "CampaignRefund",
  CampaignReturn = "CampaignReturn",
  CampaignTopUp = "CampaignTopUp",
  NegativeAllowedChange = "NegativeAllowedChange",
  PromoCredit = "PromoCredit",
  RefundDeduct = "RefundDeduct",
  SubscriptionCredit = "SubscriptionCredit",
  TopUpCard = "TopUpCard",
}

/**
 * Typical per-campaign budget bucket
 */
export enum CbCompanyBudgetRange {
  FROM_100K_TO_250K = "FROM_100K_TO_250K",
  FROM_250K_TO_500K = "FROM_250K_TO_500K",
  FROM_25K_TO_50K = "FROM_25K_TO_50K",
  FROM_500K_TO_1M = "FROM_500K_TO_1M",
  FROM_50K_TO_100K = "FROM_50K_TO_100K",
  FROM_5K_TO_25K = "FROM_5K_TO_25K",
  OVER_1M = "OVER_1M",
  UNDER_5K = "UNDER_5K",
}

export enum CbDeliverableItemV2Status {
  APPROVED = "APPROVED",
  ARCHIVED = "ARCHIVED",
  NOT_SUBMITTED = "NOT_SUBMITTED",
  ON_BRAND_REVIEW = "ON_BRAND_REVIEW",
  REJECTED = "REJECTED",
}

export enum CbDeliverableV2Status {
  APPROVED = "APPROVED",
  ARCHIVED = "ARCHIVED",
  CONTENT_APPROVED = "CONTENT_APPROVED",
  CONTENT_REJECTED = "CONTENT_REJECTED",
  NOT_SUBMITTED = "NOT_SUBMITTED",
  ON_BRAND_REVIEW = "ON_BRAND_REVIEW",
  PUBLISHED = "PUBLISHED",
  TALENT_ACTION_NEEDED = "TALENT_ACTION_NEEDED",
}

/**
 * Maps to the Stripe coupon duration
 */
export enum CbDiscountDuration {
  forever = "forever",
  once = "once",
  repeating = "repeating",
}

export enum CbDisplayPeriod {
  DAYS = "DAYS",
  WEEKS = "WEEKS",
}

export enum CbDueDateType {
  APPLICATION_BASED = "APPLICATION_BASED",
  CONTENT_BASED = "CONTENT_BASED",
  FIXED = "FIXED",
  RANGE = "RANGE",
}

/**
 * Types of Campaign Builder entitlements
 */
export enum CbEntitlementType {
  AdNewsFeed = "AdNewsFeed",
  AffiliateOffering = "AffiliateOffering",
  AppliedTalentAudienceReport = "AppliedTalentAudienceReport",
  CampaignTalentInviteLink = "CampaignTalentInviteLink",
  ChatBroadcastAll = "ChatBroadcastAll",
  CpmPayoutCampaign = "CpmPayoutCampaign",
  MyTalent = "MyTalent",
  NoLaunchFee = "NoLaunchFee",
  PremiumCampaignInsights = "PremiumCampaignInsights",
  PremiumFilter = "PremiumFilter",
  RemoveMention = "RemoveMention",
  SocialBoost = "SocialBoost",
  TalentBookingResearch = "TalentBookingResearch",
  Team = "Team",
  ZeroProcessingFee = "ZeroProcessingFee",
}

export enum CbFixedDateType {
  BEFORE = "BEFORE",
  EXACT = "EXACT",
}

export enum CbMyTalentSource {
  Invited = "Invited",
  Millions = "Millions",
}

export enum CbMyTalentStatus {
  Active = "Active",
  Archived = "Archived",
}

export enum CbMyTalentType {
  OnPlatform = "OnPlatform",
}

/**
 * Payment source for CB charges: a saved card (off-session) or the account balance
 */
export enum CbPaymentSource {
  ACCOUNT_BALANCE = "ACCOUNT_BALANCE",
  CC = "CC",
}

/**
 * What a promo code grants
 */
export enum CbPromoCodeKind {
  CreditFree = "CreditFree",
  CreditMatch = "CreditMatch",
  SubscriptionDiscount = "SubscriptionDiscount",
  SubscriptionTrial = "SubscriptionTrial",
}

/**
 * Computed usability state of a promo code
 */
export enum CbPromoCodeStatus {
  Active = "Active",
  Exhausted = "Exhausted",
  Expired = "Expired",
  Paused = "Paused",
  Scheduled = "Scheduled",
}

export enum CbSettingScope {
  Agency = "Agency",
  Global = "Global",
}

export enum CbSettingType {
  AgencySignUpEmailVerification = "AgencySignUpEmailVerification",
  CpmPayout = "CpmPayout",
  DeliverableRevisionLimit = "DeliverableRevisionLimit",
  DigitalAgreement = "DigitalAgreement",
  Fee = "Fee",
  InviteProcessingFee = "InviteProcessingFee",
  Lock = "Lock",
  NegativeBalance = "NegativeBalance",
  Pitch = "Pitch",
  ProcessingFee = "ProcessingFee",
}

/**
 * Typical per-talent fee bucket
 */
export enum CbTalentBudgetRange {
  FROM_10K_TO_25K = "FROM_10K_TO_25K",
  FROM_1K_TO_2_5K = "FROM_1K_TO_2_5K",
  FROM_250_TO_500 = "FROM_250_TO_500",
  FROM_25K_TO_100K = "FROM_25K_TO_100K",
  FROM_2_5K_TO_10K = "FROM_2_5K_TO_10K",
  FROM_500_TO_1K = "FROM_500_TO_1K",
  OVER_100K = "OVER_100K",
  UNDER_250 = "UNDER_250",
}

export enum ChannelMonetizationApplicationStatus {
  Approved = "Approved",
  Rejected = "Rejected",
  Review = "Review",
}

export enum ChannelMonetizationMilestoneType {
  Followers = "Followers",
  GuestInvites = "GuestInvites",
  InterviewNow = "InterviewNow",
  InterviewStream = "InterviewStream",
  Mentions = "Mentions",
}

export enum ChannelMonetizationProgramStatus {
  Closed = "Closed",
  Draft = "Draft",
  Open = "Open",
}

export enum ChatChannelState {
  Active = "Active",
  Archived = "Archived",
  Deleted = "Deleted",
  Frozen = "Frozen",
}

export enum ContactType {
  ATHLETE = "ATHLETE",
  BRAND = "BRAND",
}

export enum CounterOfferAction {
  ACCEPT = "ACCEPT",
  COUNTER = "COUNTER",
  REJECT = "REJECT",
}

export enum CounterOfferProposedBy {
  ATHLETE = "ATHLETE",
  BRAND = "BRAND",
}

export enum DeliverableReviewAction {
  APPROVE = "APPROVE",
  REJECT = "REJECT",
}

export enum DesignPriorityType {
  High = "High",
  Regular = "Regular",
}

export enum DesignRejectionType {
  byManager = "byManager",
  byStore = "byStore",
}

export enum DesignRequestStatus {
  Accepted = "Accepted",
  Archived = "Archived",
  AutoAccepted = "AutoAccepted",
  AwaitingApproval = "AwaitingApproval",
  InProgress = "InProgress",
  OnReview = "OnReview",
  Rejected = "Rejected",
  Todo = "Todo",
}

export enum DesignRequestType {
  LogoAudit = "LogoAudit",
  LogoCreation = "LogoCreation",
  MerchCreation = "MerchCreation",
  MerchCreationWithLogo = "MerchCreationWithLogo",
}

export enum DesignRequestsOrderBy {
  assignDate = "assignDate",
  createdAt = "createdAt",
  designRate = "designRate",
  designRequestId = "designRequestId",
  designRequestType = "designRequestType",
  designerName = "designerName",
  designerStatus = "designerStatus",
  dueDate = "dueDate",
  dueDatePriority = "dueDatePriority",
  status = "status",
  storeName = "storeName",
}

export enum DesignerStatus {
  Active = "Active",
  Inactive = "Inactive",
  Pending = "Pending",
}

export enum DesignersOrderBy {
  createdAt = "createdAt",
  designerName = "designerName",
  designerRate = "designerRate",
  designerRequestCnt = "designerRequestCnt",
  designerStatus = "designerStatus",
  firstName = "firstName",
  lastName = "lastName",
}

/**
 * Status of Campaign Builder entitlements based on validity dates
 */
export enum EntitlementStatus {
  Active = "Active",
  Inactive = "Inactive",
}

export enum ExperienceOrderBy {
  createdAt = "createdAt",
  price = "price",
  title = "title",
}

export enum ExperienceRequestStatus {
  Accepted = "Accepted",
  Declined = "Declined",
  Pending = "Pending",
  Purchased = "Purchased",
  Refunded = "Refunded",
}

export enum ExperienceSalesOrderBy {
  CreatedAt = "CreatedAt",
  CustomerEmail = "CustomerEmail",
  CustomerFirstName = "CustomerFirstName",
  Id = "Id",
  PaidAt = "PaidAt",
  RequestedProfit = "RequestedProfit",
  Status = "Status",
  Title = "Title",
}

export enum ExperienceStatus {
  Active = "Active",
  Inactive = "Inactive",
  Sold = "Sold",
}

export enum ExtTalentAthleticLevel {
  amateur = "amateur",
  college_university = "college_university",
  olympic_national = "olympic_national",
  other = "other",
  professional = "professional",
  retired_professional = "retired_professional",
}

export enum ExtTalentContactRole {
  agent = "agent",
  personal = "personal",
}

export enum ExtTalentContactStatus {
  active = "active",
  bounced = "bounced",
  suppressed = "suppressed",
  wrong_person = "wrong_person",
}

export enum ExtTalentContactType {
  email = "email",
  facebook = "facebook",
  instagram = "instagram",
  linkedin = "linkedin",
  phone = "phone",
  tiktok = "tiktok",
  twitch = "twitch",
  x = "x",
  youtube = "youtube",
}

export enum ExtTalentExportColumn {
  agentEmails = "agentEmails",
  agentNames = "agentNames",
  agentSocialNames = "agentSocialNames",
  agentSocials = "agentSocials",
  athleticLevel = "athleticLevel",
  birthDate = "birthDate",
  birthMonth = "birthMonth",
  birthYear = "birthYear",
  city = "city",
  college = "college",
  country = "country",
  firstName = "firstName",
  gender = "gender",
  homeCity = "homeCity",
  homeCountry = "homeCountry",
  homeState = "homeState",
  id = "id",
  lastEnrichedAt = "lastEnrichedAt",
  lastName = "lastName",
  league = "league",
  middleName = "middleName",
  nameSuffix = "nameSuffix",
  personalEmails = "personalEmails",
  socialFollowers = "socialFollowers",
  socialUrls = "socialUrls",
  sport = "sport",
  state = "state",
  team = "team",
}

export enum ExtTalentLinkStatus {
  active = "active",
  inactive = "inactive",
  wrong_person = "wrong_person",
}

export enum ExtTalentSocialPlatform {
  facebook = "facebook",
  instagram = "instagram",
  linkedin = "linkedin",
  tiktok = "tiktok",
  twitch = "twitch",
  x = "x",
  youtube = "youtube",
}

export enum ExtTalentSortBy {
  createdAt = "createdAt",
  totalFollowers = "totalFollowers",
}

export enum ExtTalentStatus {
  active = "active",
  irrelevant = "irrelevant",
}

export enum FeatureLimitKey {
  AutoMentions = "AutoMentions",
  GlobalFeedPresence = "GlobalFeedPresence",
  InterviewBeGuest = "InterviewBeGuest",
  InterviewInvite = "InterviewInvite",
  InterviewNow = "InterviewNow",
  MediaPostImage = "MediaPostImage",
  MediaPostVideo = "MediaPostVideo",
  MemorabiliaCreation = "MemorabiliaCreation",
  MerchCreation = "MerchCreation",
  StreamCreation = "StreamCreation",
}

export enum FeatureLimitKind {
  Monthly = "Monthly",
  Toggle = "Toggle",
}

export enum FeatureLimitSource {
  Global = "Global",
  None = "None",
  Override = "Override",
}

/**
 * Youth is deprecated
 */
export enum Gender {
  Female = "Female",
  Male = "Male",
  Unisex = "Unisex",
  Youth = "Youth",
}

export enum GenderInputFilter {
  Female = "Female",
  Male = "Male",
  Youth = "Youth",
}

export enum GetGalleryImagesOrderBy {
  createdAt = "createdAt",
  name = "name",
  updatedAt = "updatedAt",
}

export enum GetGalleryVideosOrderBy {
  createdAt = "createdAt",
  name = "name",
  updatedAt = "updatedAt",
}

export enum GetMyInvoicesOrderBy {
  createdAt = "createdAt",
  status = "status",
  total = "total",
}

export enum GetRedirectsOrderBy {
  createdAt = "createdAt",
  from = "from",
  to = "to",
  updatedAt = "updatedAt",
}

export enum HashtagsFilterOrderBy {
  name = "name",
}

export enum HostedTicketEventsOrderBy {
  CreatedAt = "CreatedAt",
  Name = "Name",
  StartsAt = "StartsAt",
  TicketPrice = "TicketPrice",
}

/**
 * Invited - Invited Manually bia backoffice
 * AutoInvited - Invited via trigger
 * Completed - completed manually by admin
 * AutoCompleted - stream finished and all records are ready
 * Canceled - cancelled manually by interviewer/admin
 * AutoCancelled - stream was cancelled (ex. Auto cancel if no one showed up) and as a result interview
 * CompleteFailed - stream ended without all records
 */
export enum InterviewAuditLogAction {
  Assigned = "Assigned",
  AutoCancelled = "AutoCancelled",
  AutoCompleted = "AutoCompleted",
  AutoInvited = "AutoInvited",
  Canceled = "Canceled",
  CompleteFailed = "CompleteFailed",
  Completed = "Completed",
  InviteViewed = "InviteViewed",
  Invited = "Invited",
  NoAvailableInterviewerFound = "NoAvailableInterviewerFound",
  RescheduleRequested = "RescheduleRequested",
  Reset = "Reset",
  ScheduleAttempted = "ScheduleAttempted",
  Scheduled = "Scheduled",
  StreamEdited = "StreamEdited",
}

/**
 * Automatic - Event-triggered (ex. expensive Memorabilia was created) or user initiated througth web
 * Manual - Created manually via backoffice or sent via campaign
 */
export enum InterviewCreationType {
  Automatic = "Automatic",
  Manual = "Manual",
}

/**
 * Apitemplate will be creating image asynchronously so this status is used to track the status of the image creation
 */
export enum InterviewImageStatus {
  completed = "completed",
  failed = "failed",
  inProgress = "inProgress",
}

/**
 * Topic categories for interview questions
 */
export enum InterviewQuestionTopic {
  LocalSportScene = "LocalSportScene",
  Trending = "Trending",
  Viral = "Viral",
}

export enum InterviewSettingType {
  GeneralSettings = "GeneralSettings",
  HighValueMemorabiliaTrigger = "HighValueMemorabiliaTrigger",
  HighValueMerchTrigger = "HighValueMerchTrigger",
  InterviewNowDispatchSettings = "InterviewNowDispatchSettings",
  InterviewNowGeneralSettings = "InterviewNowGeneralSettings",
  PPVParticipantTrigger = "PPVParticipantTrigger",
  UserRequest = "UserRequest",
}

export enum InterviewSourceType {
  BigMoment = "BigMoment",
  InterviewNow = "InterviewNow",
  Memorabilia = "Memorabilia",
  Merch = "Merch",
  Other = "Other",
  PPVParticipant = "PPVParticipant",
  Paid = "Paid",
  Product = "Product",
  QAMillions = "QAMillions",
  TalentInvite = "TalentInvite",
  TicketEventParticipant = "TicketEventParticipant",
  UserRequest = "UserRequest",
}

/**
 * Invited - Invite is sent with or without interviewer assigned
 * InviteViewed - Interviewee visited Millions invite link, Interviewer auto-assign happens at this stage
 * ScheduleAttempted - Calendly link was opened
 * Scheduled - Interviewer/Admin setup a stream date
 * Completed - Stream has successfully ended AND all records are ready
 * Canceled - Either manually cancelled or automatically (nobody attended stream)
 */
export enum InterviewStatus {
  Canceled = "Canceled",
  Completed = "Completed",
  Draft = "Draft",
  InviteViewed = "InviteViewed",
  Invited = "Invited",
  RescheduleRequested = "RescheduleRequested",
  ScheduleAttempted = "ScheduleAttempted",
  Scheduled = "Scheduled",
}

export enum InterviewerTasksOrderBy {
  aiClipsCreatedAt = "aiClipsCreatedAt",
  createdAt = "createdAt",
  interviewName = "interviewName",
  intervieweeName = "intervieweeName",
  scheduledAt = "scheduledAt",
}

/**
 * The status of the invoice
 */
export enum InvoiceStatus {
  draft = "draft",
  open = "open",
  paid = "paid",
  uncollectible = "uncollectible",
  upcoming = "upcoming",
  void = "void",
}

/**
 * The type of invoice
 */
export enum InvoiceType {
  CbBalanceTopUp = "CbBalanceTopUp",
  Subscription = "Subscription",
}

/**
 * Campaign type a brand usually runs
 */
export enum MarketingChannel {
  AFFILIATE_MARKETING = "AFFILIATE_MARKETING",
  BRAND_AMBASSADORS = "BRAND_AMBASSADORS",
  CONTENT_CREATION = "CONTENT_CREATION",
  EVENT_SPONSORSHIPS = "EVENT_SPONSORSHIPS",
  EXPERIENTIAL_MARKETING = "EXPERIENTIAL_MARKETING",
  INFLUENCER_MARKETING = "INFLUENCER_MARKETING",
  NIL_DEALS = "NIL_DEALS",
  PAID_MEDIA = "PAID_MEDIA",
  PRODUCT_PLACEMENT = "PRODUCT_PLACEMENT",
  SOCIAL_COLLABORATIONS = "SOCIAL_COLLABORATIONS",
}

export enum MatchupCorner {
  A = "A",
  B = "B",
}

export enum MediaJobStatus {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  PROCESSING = "PROCESSING",
}

export enum MediaPostStatus {
  published = "published",
  scheduled = "scheduled",
  scheduledInstant = "scheduledInstant",
}

export enum MediaPostType {
  ImagePost = "ImagePost",
  VideoPost = "VideoPost",
}

export enum MediaPostsOrderBy {
  publishedAt = "publishedAt",
}

export enum MemorabiliaFulfillment {
  Athlete = "Athlete",
  Millions = "Millions",
}

export enum MemorabiliaOrderBy {
  createdAt = "createdAt",
  inappropriateImageCount = "inappropriateImageCount",
  price = "price",
  socialFollowerCount = "socialFollowerCount",
  title = "title",
}

export enum MemorabiliaProductType {
  Memorabilia = "Memorabilia",
  Product = "Product",
}

export enum MemorabiliaSaleMethod {
  auction = "auction",
  standard = "standard",
}

export enum MemorabiliaStatus {
  Active = "Active",
  Expired = "Expired",
  Removed = "Removed",
  Sold = "Sold",
}

export enum MentionType {
  ARTICLE = "ARTICLE",
  EDITED_VIDEO = "EDITED_VIDEO",
  MEDIA_POST = "MEDIA_POST",
  STREAM = "STREAM",
  VIDEO_REQUEST = "VIDEO_REQUEST",
}

export enum MerchCreationSource {
  Ai = "Ai",
  AutoGenerated = "AutoGenerated",
  Manual = "Manual",
}

/**
 * Used as a generic status for SubOrder
 */
export enum MerchOrderStatus {
  Canceled = "Canceled",
  Completed = "Completed",
  Pending = "Pending",
  Processing = "Processing",
}

export enum MerchProductOrderBy {
  Date = "Date",
  Price = "Price",
  StoreName = "StoreName",
  Title = "Title",
}

export enum MerchProductStatus {
  Active = "Active",
  Inactive = "Inactive",
  MockupsFailed = "MockupsFailed",
  PendingMockups = "PendingMockups",
}

export enum MerchProductType {
  Hat = "Hat",
  Joggers = "Joggers",
  ManHoodie = "ManHoodie",
  ManJoggers = "ManJoggers",
  ManRashGuard = "ManRashGuard",
  ManTShirt = "ManTShirt",
  ManTankTop = "ManTankTop",
  WomanHoodie = "WomanHoodie",
  WomanJoggers = "WomanJoggers",
  WomanRashGuard = "WomanRashGuard",
  WomanTShirt = "WomanTShirt",
  WomanTankTop = "WomanTankTop",
  YouthTShirt = "YouthTShirt",
}

export enum MerchType {
  Hat = "Hat",
  Hoodie = "Hoodie",
  Joggers = "Joggers",
  RashGuard = "RashGuard",
  TShirt = "TShirt",
}

export enum ModeratorsOrderBy {
  createdAt = "createdAt",
  firstName = "firstName",
  lastName = "lastName",
  moderatorName = "moderatorName",
}

export enum MyCbTalentSortKey {
  Added = "Added",
  Followers = "Followers",
  LastRate = "LastRate",
  Location = "Location",
  Name = "Name",
  RecentlyWorkedWith = "RecentlyWorkedWith",
}

export enum MyTipsAndOrdersSalesOrderBy {
  CustomerEmail = "CustomerEmail",
  CustomerFirstName = "CustomerFirstName",
  Discount = "Discount",
  Earnings = "Earnings",
  PaidAt = "PaidAt",
  Type = "Type",
}

export enum OrganizationType {
  AssociationLeagueTeam = "AssociationLeagueTeam",
  EventOrganizer = "EventOrganizer",
  Gym = "Gym",
  Other = "Other",
}

export enum PlacementTypes {
  back = "back",
  embroidery_back = "embroidery_back",
  embroidery_front = "embroidery_front",
  embroidery_front_large = "embroidery_front_large",
  embroidery_left = "embroidery_left",
  embroidery_right = "embroidery_right",
  front = "front",
  leg_back_left = "leg_back_left",
  leg_back_right = "leg_back_right",
  leg_front_left = "leg_front_left",
  leg_front_right = "leg_front_right",
  pocket = "pocket",
  sleeve_left = "sleeve_left",
  sleeve_right = "sleeve_right",
}

export enum ProductSalesType {
  memorabilia = "memorabilia",
  merch = "merch",
  product = "product",
}

export enum ProductTypesType {
  Ama = "Ama",
  Experience = "Experience",
  Merch = "Merch",
  Product = "Product",
  Shoutout = "Shoutout",
  Stream = "Stream",
  Ticket = "Ticket",
}

export enum PromoCodesChargeSubject {
  Internal = "Internal",
  Platform = "Platform",
  Store = "Store",
}

export enum PromoCodesOrderBy {
  amount = "amount",
  chargeSubject = "chargeSubject",
  createdAt = "createdAt",
  endDate = "endDate",
  name = "name",
  startDate = "startDate",
}

export enum PromocodesOrderBy {
  createdAt = "createdAt",
  endDate = "endDate",
  name = "name",
  startDate = "startDate",
}

export enum PsychosocialKeywordOrderBy {
  name = "name",
}

export enum PublicStreamCategory {
  Interview = "Interview",
  Stream = "Stream",
}

export enum ScheduleEventStatus {
  Cancelled = "Cancelled",
  Enabled = "Enabled",
}

export enum ScheduleRuleType {
  Date = "Date",
  WeekDay = "WeekDay",
}

export enum ScheduleType {
  Interview = "Interview",
}

export enum SearchCampaignStoresOrderBy {
  fullName = "fullName",
  profileName = "profileName",
  socialOrMillionsFollowers = "socialOrMillionsFollowers",
  totalFollowing = "totalFollowing",
}

export enum SignUpFlow {
  QuickFlow = "QuickFlow",
  RegularFlow = "RegularFlow",
}

export enum SignUpSource {
  BookMeProfile = "BookMeProfile",
  CbMentionLandingPage = "CbMentionLandingPage",
  CbTalentInviteLink = "CbTalentInviteLink",
  ExtTalentBrandDeal = "ExtTalentBrandDeal",
  PersonMention = "PersonMention",
}

/**
 * Admin ruling on a disputed Social Boost share: APPROVE pays out the talent,
 * CANCEL voids the deal and refunds the budget, RESET reopens it for re-submission.
 */
export enum SocialBoostDisputeResolution {
  APPROVE = "APPROVE",
  CANCEL = "CANCEL",
  RESET = "RESET",
}

export enum SocialMediaIntegrationSettingType {
  CbSocialMediaFlowSettings = "CbSocialMediaFlowSettings",
  NewFlowSettings = "NewFlowSettings",
}

export enum SocialMediaType {
  Facebook = "Facebook",
  Instagram = "Instagram",
  Tiktok = "Tiktok",
  Twitter = "Twitter",
  Youtube = "Youtube",
}

export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export enum SponsoredAppearanceVideoType {
  Live = "Live",
  Recorded = "Recorded",
}

export enum StoreAthleticLevel {
  Amateur = "Amateur",
  CollegeUniversity = "CollegeUniversity",
  OlympicNational = "OlympicNational",
  Other = "Other",
  Professional = "Professional",
  RetiredProfessional = "RetiredProfessional",
}

export enum StoreCareerStatus {
  Active = "Active",
  Retired = "Retired",
}

export enum StoreGender {
  female = "female",
  male = "male",
  other = "other",
  preferNotToSay = "preferNotToSay",
}

export enum StoreInterviewerOrderBy {
  createdAt = "createdAt",
  firstName = "firstName",
  lastName = "lastName",
}

export enum StoreStatus {
  Active = "Active",
  Inactive = "Inactive",
  Pending = "Pending",
  Rejected = "Rejected",
}

export enum StoresOrderBy {
  activatedAt = "activatedAt",
  createdAt = "createdAt",
  firstName = "firstName",
  followerCount = "followerCount",
  lastName = "lastName",
  socialFollowerCount = "socialFollowerCount",
  storeName = "storeName",
  totalSales = "totalSales",
}

export enum StreamAffiliateLinkStatus {
  Active = "Active",
  Disabled = "Disabled",
}

export enum StreamAffiliateLinksOrderBy {
  Clicks = "Clicks",
  Commission = "Commission",
  Name = "Name",
  Revenue = "Revenue",
  Sales = "Sales",
  TicketsSold = "TicketsSold",
}

export enum StreamClipStatus {
  Complete = "Complete",
  Error = "Error",
  Processing = "Processing",
}

export enum StreamIntervalEnum {
  biweekly = "biweekly",
  monthly = "monthly",
  weekly = "weekly",
}

export enum StreamOrderBy {
  AiClipsCreatedAt = "AiClipsCreatedAt",
  Description = "Description",
  Name = "Name",
  Price = "Price",
  RequestedPrice = "RequestedPrice",
  ScheduleDate = "ScheduleDate",
  ScheduleDateStrict = "ScheduleDateStrict",
  StoreName = "StoreName",
  StreamStatus = "StreamStatus",
}

export enum StreamOrderByFilter {
  createdAt = "createdAt",
  email = "email",
  name = "name",
  orderStatus = "orderStatus",
  price = "price",
  scheduleDate = "scheduleDate",
  streamStatus = "streamStatus",
}

export enum StreamOrderSalesOrderBy {
  CreatedAt = "CreatedAt",
  CustomerFirstName = "CustomerFirstName",
  DiscountAmount = "DiscountAmount",
  PaidAt = "PaidAt",
  RequestedProfit = "RequestedProfit",
}

export enum StreamOrderStatus {
  Cancelled = "Cancelled",
  Completed = "Completed",
  Pending = "Pending",
  Processing = "Processing",
}

export enum StreamParticipantRowStatus {
  Active = "Active",
  Invited = "Invited",
}

export enum StreamPriceCategory {
  Free = "Free",
  Paid = "Paid",
}

export enum StreamSalesOrderBy {
  Earnings = "Earnings",
  Name = "Name",
  OrderCnt = "OrderCnt",
  ScheduleDate = "ScheduleDate",
  TipCnt = "TipCnt",
}

export enum StreamStatus {
  Active = "Active",
  Cancelled = "Cancelled",
  Ended = "Ended",
  Interrupted = "Interrupted",
  Paused = "Paused",
  Scheduled = "Scheduled",
}

export enum StreamSubtypeFilter {
  GuestInterview = "GuestInterview",
  HostInterview = "HostInterview",
  Participant = "Participant",
  Regular = "Regular",
  SponsoredAppearance = "SponsoredAppearance",
}

/**
 * Subscription billing scheme
 */
export enum SubBillingScheme {
  per_unit = "per_unit",
  tiered = "tiered",
}

/**
 * Subscription product sub type
 */
export enum SubProductSubType {
  free_plan = "free_plan",
  full_plan = "full_plan",
  plan_credit = "plan_credit",
  pro_plan = "pro_plan",
  team_plan = "team_plan",
  team_seat = "team_seat",
}

/**
 * Subscription product type
 */
export enum SubProductType {
  cb_addon = "cb_addon",
  cb_plan = "cb_plan",
}

/**
 * Subscription recurring interval
 */
export enum SubRecurringInterval {
  daily = "daily",
  every_3_months = "every_3_months",
  every_6_months = "every_6_months",
  monthly = "monthly",
  weekly = "weekly",
  yearly = "yearly",
}

/**
 * Subscription usage type
 */
export enum SubUsageType {
  licensed = "licensed",
  metered = "metered",
}

/**
 * Subscription status
 */
export enum SubscriptionStatus {
  active = "active",
  cancelled = "cancelled",
  incomplete = "incomplete",
  incomplete_expired = "incomplete_expired",
  past_due = "past_due",
  paused = "paused",
  trialing = "trialing",
  unpaid = "unpaid",
}

/**
 * Subscription type
 */
export enum SubscriptionType {
  cb_plan = "cb_plan",
}

export enum TalentInviteLinkType {
  ALL_DEALS = "ALL_DEALS",
  SPECIFIC_CAMPAIGN = "SPECIFIC_CAMPAIGN",
}

export enum TargetType {
  REGISTERED = "REGISTERED",
  UNREGISTERED = "UNREGISTERED",
}

export enum TaskExtensionRequestStatus {
  APPROVED = "APPROVED",
  ARCHIVED = "ARCHIVED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export enum TaskExtensionRequestType {
  CONTENT = "CONTENT",
  EVENT = "EVENT",
  PUBLISH = "PUBLISH",
}

export enum TicketCompCategory {
  Fighter = "Fighter",
  Guest = "Guest",
  Media = "Media",
  Other = "Other",
  Sponsor = "Sponsor",
}

export enum TicketEventOrderSort {
  AdmissionCount = "AdmissionCount",
  Amount = "Amount",
  CreatedAt = "CreatedAt",
  CustomerName = "CustomerName",
  Reference = "Reference",
  Status = "Status",
}

export enum TicketEventStatus {
  Cancelled = "Cancelled",
  Closed = "Closed",
  Draft = "Draft",
  OnSale = "OnSale",
  Paused = "Paused",
  Postponed = "Postponed",
}

export enum TicketOrderKind {
  Comp = "Comp",
  Purchase = "Purchase",
}

export enum TicketOrderStatus {
  Cancelled = "Cancelled",
  Confirmed = "Confirmed",
  Expired = "Expired",
  PaymentReview = "PaymentReview",
  PendingPayment = "PendingPayment",
  RefundPending = "RefundPending",
  Refunded = "Refunded",
  Reserved = "Reserved",
}

export enum TicketRedemptionResult {
  AdmissionClosed = "AdmissionClosed",
  Admitted = "Admitted",
  AlreadyAdmitted = "AlreadyAdmitted",
  DoorsNotOpen = "DoorsNotOpen",
  EventCancelled = "EventCancelled",
  EventNotPublished = "EventNotPublished",
  EventPostponed = "EventPostponed",
  Invalid = "Invalid",
  Revoked = "Revoked",
  WrongEvent = "WrongEvent",
}

export enum TicketScanSort {
  Result = "Result",
  ScannedAt = "ScannedAt",
}

export enum TicketStatus {
  Active = "Active",
  Admitted = "Admitted",
  Revoked = "Revoked",
}

export enum TicketTaxMode {
  ApprovedZero = "ApprovedZero",
  Unconfigured = "Unconfigured",
}

/**
 * Type of transition
 */
export enum TransitionType {
  MiddleOfVideo = "MiddleOfVideo",
  Outro = "Outro",
}

export enum UnmergedMerchOrderBy {
  createdAt = "createdAt",
  title = "title",
  type = "type",
}

export enum UnregisteredContactOrderBy {
  createdAt = "createdAt",
  name = "name",
  timesMentioned = "timesMentioned",
}

export enum UserAreaOfInfluenceOrderBy {
  name = "name",
}

/**
 * Gym is deprecated and substituted with Organization
 */
export enum UserRole {
  Admin = "Admin",
  Agency = "Agency",
  Association = "Association",
  Athlete = "Athlete",
  Charity = "Charity",
  Coach = "Coach",
  ContentCreator = "ContentCreator",
  Customer = "Customer",
  Designer = "Designer",
  Guest = "Guest",
  Gym = "Gym",
  ManagementFirm = "ManagementFirm",
  Moderator = "Moderator",
  Organization = "Organization",
  Team = "Team",
  Trainer = "Trainer",
  VideoEditor = "VideoEditor",
}

export enum UsersOrderFields {
  createdAt = "createdAt",
  email = "email",
  facebookLink = "facebookLink",
  firstName = "firstName",
  instagramLink = "instagramLink",
  lastName = "lastName",
  phoneNumber = "phoneNumber",
  role = "role",
  slug = "slug",
  socialMediaLink = "socialMediaLink",
  status = "status",
  tiktokLink = "tiktokLink",
  twitterLink = "twitterLink",
}

export enum VideoEditRequestAuditLogAction {
  Approve = "Approve",
  Archive = "Archive",
  Assign = "Assign",
  AutoCreated = "AutoCreated",
  CreatedAndAssigned = "CreatedAndAssigned",
  Reassign = "Reassign",
  RejectAndSendBack = "RejectAndSendBack",
  RejectAndSendReassign = "RejectAndSendReassign",
}

export enum VideoEditRequestSettingType {
  InterviewTrigger = "InterviewTrigger",
  MediaLabTrigger = "MediaLabTrigger",
  SponsoredAppearanceTrigger = "SponsoredAppearanceTrigger",
  StreamTrigger = "StreamTrigger",
}

export enum VideoEditRequestSourceType {
  Interview = "Interview",
  MediaPost = "MediaPost",
  SponsoredAppearance = "SponsoredAppearance",
  Stream = "Stream",
}

/**
 * Todo - created from trigger if no editors available
 */
export enum VideoEditRequestStatus {
  Accepted = "Accepted",
  Archived = "Archived",
  AutoAccepted = "AutoAccepted",
  InProgress = "InProgress",
  OnReview = "OnReview",
  PartialyRejected = "PartialyRejected",
  Rejected = "Rejected",
  Todo = "Todo",
}

export enum VideoEditRequestSubmissionStatus {
  Approved = "Approved",
  AutoApproved = "AutoApproved",
  Pending = "Pending",
  Rejected = "Rejected",
}

export enum VideoEditRequestsOrderBy {
  assignedEditor = "assignedEditor",
  createdAt = "createdAt",
  dueDate = "dueDate",
  status = "status",
  storeName = "storeName",
  videoEditRequestType = "videoEditRequestType",
  videoEditorName = "videoEditorName",
}

export enum VideoEditorOrderBy {
  createdAt = "createdAt",
  firstName = "firstName",
  lastName = "lastName",
  videoEditorName = "videoEditorName",
  videoEditorRate = "videoEditorRate",
  videoEditorStatus = "videoEditorStatus",
}

export enum VideoRequestFeedBackType {
  Accepted = "Accepted",
  Reassigned = "Reassigned",
  Rejected = "Rejected",
}

export enum WeekDay {
  friday = "friday",
  monday = "monday",
  saturday = "saturday",
  sunday = "sunday",
  thursday = "thursday",
  tuesday = "tuesday",
  wednesday = "wednesday",
}

export interface AcceptAiClipCandidateInput {
  body?: string | null;
  candidateId: string;
  hashtagInputs?: HashtagInput[] | null;
  mentionsInputs?: CreateMentionInput[] | null;
  ownerId?: string | null;
  title?: string | null;
}

export interface AcceptMerchDesignInput {
  designRequestId: string;
  feedback?: string | null;
  rate?: number | null;
}

export interface AcceptVideoEditRequestInput {
  feedback?: string | null;
  rate: number;
  videoEditRequestId: string;
  videoEditorId?: string | null;
}

export interface AddAiClipNoteInput {
  clipName: string;
  note: string;
  streamRecordId?: number | null;
  streamSlug: string;
  userSlug: string;
}

export interface AddBannedEmailDomainInput {
  domain: string;
  reason?: string | null;
}

export interface AddBrandProductCategoryInput {
  name: string;
}

export interface AddBrandRestrictedCategoryInput {
  name: string;
}

export interface AddConnectedAccountWithLinkInput {
  businessType: BusinessType;
  country?: string | null;
  refreshUrl?: string | null;
  returnUrl?: string | null;
  userId: string;
}

export interface AddHashtagInput {
  name: string;
  sportIds?: number[] | null;
}

export interface AddInfluencerCategoryInput {
  name: string;
}

export interface AddKeywordInput {
  name: string;
}

export interface AddMyCbTalentAdminInput {
  agencyId: string;
  firstWorkedAt?: any | null;
  lastRate?: number | null;
  lastWorkedAt?: any | null;
  source?: CbMyTalentSource | null;
  userId: string;
}

export interface AddOfferToCampaignInput {
  campaignId: string;
  talentId: string;
}

export interface AddStreamAffiliateInput {
  commissionPercent?: number | null;
  streamId?: string | null;
  ticketEventId?: string | null;
  userId: string;
}

export interface AddTicketTierInput {
  capacity: number;
  description?: string | null;
  label: string;
  maxPerOrder?: number | null;
  price: number;
  salesCloseAt?: any | null;
  salesOpenAt?: any | null;
  ticketEventId: string;
}

export interface AddUserAreaOfInfluenceInput {
  name: string;
}

export interface AdminAdjustCbBalanceInput {
  ownerId: string;
  paidDelta?: number | null;
  promoDelta?: number | null;
  reason: string;
}

export interface AdminArchiveMerchDesignInput {
  designRequestId: string;
}

export interface AdminAssignToDesignerInput {
  designRequestId: string;
  designerId: string;
}

export interface AdminCancelStreamOrderInput {
  streamOrderId: string;
}

export interface AdminChangePasswordInput {
  id: string;
  newPassword: string;
}

export interface AdminClearDeleteRequestInput {
  userId: string;
}

export interface AdminCreateAmasInput {
  amas: AmaItemCreateInput[];
  storeId: string;
  video?: VideoCroppedInput | null;
  videoV2?: AmaVideoInput | null;
}

export interface AdminCreateExtTalentAvatarUrlInput {
  ext: string;
  extTalentId: string;
}

export interface AdminCreateExtTalentContactInput {
  agentName?: string | null;
  extTalentId: string;
  role?: ExtTalentContactRole | null;
  type: ExtTalentContactType;
  value: string;
}

export interface AdminCreateExtTalentInput {
  athleticLevel?: ExtTalentAthleticLevel | null;
  avatarKey?: string | null;
  birthDate?: number | null;
  birthMonth?: number | null;
  birthYear?: number | null;
  city?: string | null;
  collegeUniversity?: string | null;
  collegeUniversityRaw?: string | null;
  country?: string | null;
  firstName: string;
  gender?: StoreGender | null;
  homeCity?: string | null;
  homeCountry?: string | null;
  homeState?: string | null;
  lastName: string;
  league?: string | null;
  leagueRaw?: string | null;
  middleName?: string | null;
  sport?: string | null;
  state?: string | null;
  team?: string | null;
  teamRaw?: string | null;
}

export interface AdminCreateExtTalentSocialInput {
  avatarKey?: string | null;
  extTalentId: string;
  followersCount?: number | null;
  handle: string;
  platform: ExtTalentSocialPlatform;
  profileName?: string | null;
  status?: ExtTalentLinkStatus | null;
}

export interface AdminCreateGalleryImageInput {
  file: any;
  name?: string | null;
}

export interface AdminCreateGalleryVideoInput {
  file: any;
  name?: string | null;
}

export interface AdminCreateMerchDesignInput {
  designColorPaletteIds: number[];
  designCustomColor?: string | null;
  designExtraInfo?: string | null;
  designName: string;
  designSampleIds: number[];
  designStyleSettingsInput: DesignStyleSettingsInput;
  designTypeIds: number[];
  designerId?: string | null;
  merchProductTypes?: MerchProductType[] | null;
  merchTypes?: MerchType[] | null;
  socialMediaURL?: string | null;
  storeExampleImages?: CreateStoreExampleImageInput[] | null;
  storeId: string;
}

export interface AdminCreatePostImagePresignedUrlV2Input {
  files: CreatePostImagePresignedUrlV2FileInput[];
  mediaPostId?: string | null;
  storeId: string;
}

export interface AdminDeleteAccountInput {
  userId: string;
}

export interface AdminDeleteGalleryImageInput {
  id: string;
}

export interface AdminDeleteGalleryVideoInput {
  id: string;
}

export interface AdminEditAmasInput {
  amas?: AmaItemEditInput[] | null;
  deleteVideo?: boolean | null;
  storeId: string;
  video?: VideoCroppedInput | null;
  videoV2?: AmaVideoInput | null;
}

export interface AdminEditInput {
  adminId: string;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  newPassword?: string | null;
  phoneNumber?: string | null;
}

export interface AdminEditMerchDesignInput {
  designColorPaletteIds?: number[] | null;
  designCustomColor?: string | null;
  designExtraInfo?: string | null;
  designName?: string | null;
  designRequestId: string;
  designSampleIds?: number[] | null;
  designStyleSettingsInput?: DesignStyleSettingsInput | null;
  designTypeIds?: number[] | null;
  merchProductTypes?: MerchProductType[] | null;
  merchTypes?: MerchType[] | null;
  socialMediaPackImages?: SocialMediaPackImageInput[] | null;
  socialMediaURL?: string | null;
  storeExampleImages?: CreateStoreExampleImageInput[] | null;
  storeId: string;
}

export interface AdminEditMerchDesignWithLogoInput {
  designExtraInfo?: string | null;
  designRequestId: string;
  merchProductTypes?: MerchProductType[] | null;
  merchTypes?: MerchType[] | null;
  socialMediaPackImages?: SocialMediaPackImageInput[] | null;
  socialMediaURL?: string | null;
  storeExampleImages?: CreateStoreExampleImageInput[] | null;
  storeId: string;
  storeLogos?: CreateMerchDesignLogoInput[] | null;
}

export interface AdminFilterInput {
  adminIds?: string[] | null;
  direction?: SortDirection | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  limit?: number | null;
  name?: string | null;
  offset?: number | null;
  orderBy?: AdminOrderBy | null;
  phoneNumber?: number | null;
  status?: StoreStatus[] | null;
}

/**
 * Two modes: amount alone (drawn by the standard 1-1 wallet spend rule) XOR
 * explicit paidAmount and/or promoAmount (admin picks the buckets)
 */
export interface AdminFundCampaignFromBalanceInput {
  amount?: number | null;
  campaignId: string;
  paidAmount?: number | null;
  promoAmount?: number | null;
  reason: string;
}

export interface AdminGetGalleryImagesInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: GetGalleryImagesOrderBy | null;
}

export interface AdminGetGalleryVideosInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: GetGalleryVideosOrderBy | null;
}

export interface AdminInitVideoPostMultipartUploadInput {
  contentType: string;
  fileExt: string;
  mediaPostId?: string | null;
  partCnt: number;
  storeId: string;
}

export interface AdminPreviewCbTeamOwnershipTransferInput {
  fromOwnerId: string;
  toOwnerId: string;
}

/**
 * Two modes: amount alone (pro-rata by the campaign funding ratio) XOR explicit paidAmount and/or promoAmount
 */
export interface AdminReturnCampaignBudgetInput {
  amount?: number | null;
  campaignId: string;
  paidAmount?: number | null;
  promoAmount?: number | null;
  reason: string;
}

export interface AdminSearchExtTalentsInput {
  athleticLevels?: ExtTalentAthleticLevel[] | null;
  avgEngagement?: FromToFilter | null;
  bioHashtags?: string | null;
  birthYear?: FromToFilter | null;
  collegeUniversity?: string | null;
  contact?: ExtTalentContactFilterInput | null;
  direction?: SortDirection | null;
  extTalentIds?: string[] | null;
  followersCount?: FromToFilter | null;
  genders?: StoreGender[] | null;
  hasEmail?: boolean | null;
  homeLocations?: ExtTalentLocationInput[] | null;
  isOnPlatform?: boolean | null;
  league?: string | null;
  limit?: number | null;
  locations?: ExtTalentLocationInput[] | null;
  name?: string | null;
  offset?: number | null;
  profileName?: string | null;
  query?: string | null;
  socialHandle?: string | null;
  socialPlatform?: ExtTalentSocialPlatform | null;
  sortBy?: ExtTalentSortBy | null;
  sports?: string[] | null;
  team?: string | null;
}

export interface AdminSetCbBalanceNegativeAllowedInput {
  allowed: boolean;
  ownerId: string;
  reason: string;
}

export interface AdminSetProductSuborderShippedInput {
  suborderId: string;
}

export interface AdminStoresFilterInput {
  activatedAtDateRange?: FromToDatesFilter | null;
  areaOfInfluenceIds?: string[] | null;
  direction?: SortDirection | null;
  email?: string | null;
  facebookLink?: string | null;
  firstName?: string | null;
  followersRange?: FromToFilter | null;
  hasActiveAma?: boolean | null;
  hasActiveExperiences?: boolean | null;
  hasActiveMerch?: boolean | null;
  hasActiveProducts?: boolean | null;
  hasActiveStreams?: boolean | null;
  hasAma?: boolean | null;
  hasAreaOfInfluence?: boolean | null;
  hasArticle?: boolean | null;
  hasBirthDate?: boolean | null;
  hasContent?: boolean | null;
  hasExperiences?: boolean | null;
  hasFacebook?: boolean | null;
  hasInstagram?: boolean | null;
  hasMerch?: boolean | null;
  hasOpenDesignRequest?: boolean | null;
  hasProducts?: boolean | null;
  hasPsychosocialKeywords?: boolean | null;
  hasStreams?: boolean | null;
  hasTiktok?: boolean | null;
  hasTwitter?: boolean | null;
  hasWebsite?: boolean | null;
  hasYoutube?: boolean | null;
  hashtagIds?: number[] | null;
  id?: string | null;
  initialAssessmentRange?: AssessmentRangeInput | null;
  instagramLink?: string | null;
  isDeleteRequested?: boolean | null;
  isOnboarded?: boolean | null;
  isShoppingEnabled?: boolean | null;
  isStreamer?: boolean | null;
  latestAssessmentRange?: AssessmentRangeInput | null;
  limit?: number | null;
  managedByName?: string | null;
  offset?: number | null;
  orderBy?: AdminStoresOrderBy | null;
  phoneNumber?: number | null;
  phoneNumberV2?: string | null;
  psychosocialKeywordsIds?: string[] | null;
  revenueRange?: FromToFilter | null;
  searchTerm?: string | null;
  signUpDateRange?: FromToDatesFilter | null;
  slug?: string | null;
  socialFollowersRange?: FromToFilter | null;
  socialMediaLink?: string | null;
  sportId?: number | null;
  sports?: number[] | null;
  status?: StoreStatus[] | null;
  storeIds?: string[] | null;
  storeName?: string | null;
  tiktokLink?: string | null;
  twitterLink?: string | null;
  withOrphans?: boolean | null;
}

export interface AdminTicketOrdersInput {
  buyerUserId?: string | null;
  createdFrom?: any | null;
  createdTo?: any | null;
  direction?: SortDirection | null;
  kinds?: TicketOrderKind[] | null;
  limit?: number | null;
  offset?: number | null;
  searchTerm?: string | null;
  sortBy?: TicketEventOrderSort | null;
  statuses?: TicketOrderStatus[] | null;
  ticketEventId?: string | null;
}

export interface AdminTransferCbTeamOwnershipInput {
  fromOwnerId: string;
  reason?: string | null;
  toOwnerId: string;
}

export interface AdminUpdateExtTalentContactInput {
  agentName?: string | null;
  id: string;
  status: ExtTalentContactStatus;
}

export interface AdminUpdateExtTalentInput {
  athleticLevel?: ExtTalentAthleticLevel | null;
  avatarKey?: string | null;
  birthDate?: number | null;
  birthMonth?: number | null;
  birthYear?: number | null;
  city?: string | null;
  collegeUniversity?: string | null;
  collegeUniversityRaw?: string | null;
  country?: string | null;
  firstName?: string | null;
  gender?: StoreGender | null;
  homeCity?: string | null;
  homeCountry?: string | null;
  homeState?: string | null;
  id: string;
  lastName?: string | null;
  league?: string | null;
  leagueRaw?: string | null;
  middleName?: string | null;
  sport?: string | null;
  state?: string | null;
  status?: ExtTalentStatus | null;
  team?: string | null;
  teamRaw?: string | null;
}

export interface AdminUpdateExtTalentSocialInput {
  avatarKey?: string | null;
  followersCount?: number | null;
  id: string;
  profileName?: string | null;
  status?: ExtTalentLinkStatus | null;
}

export interface AffiliateCommissionPayoutsInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  paidAtDateRange?: FromToDatesFilter | null;
  storeId?: string | null;
}

export interface AffiliateStreamsInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: AffiliateStreamsOrderBy | null;
  search?: string | null;
}

export interface AgencyEditInput {
  agencyId: string;
  avatarKey?: string | null;
  city?: string | null;
  companyDomains?: string[] | null;
  companyName?: string | null;
  country?: string | null;
  email?: string | null;
  firstName?: string | null;
  jobTitle?: string | null;
  lastName?: string | null;
  location?: EarthCoordinateInput | null;
  phoneNumber?: string | null;
  productCategoryIds?: string[] | null;
  restrictedCategoryIds?: string[] | null;
  state?: string | null;
}

export interface AgencySignUpEmailVerificationSettingDetailsInput {
  enabled: boolean;
}

export interface AiClipNoteInput {
  clipName: string;
  note?: string | null;
}

export interface AiClipperAutoApprovalConfigInput {
  autoApprovalHours: number;
}

export interface AiClipperAutoApprovalSettingInput {
  config?: AiClipperAutoApprovalConfigInput | null;
  isEnabled?: boolean | null;
}

export interface AiClipperMetricsFilterInput {
  approvalSources?: AiClipCandidateApprovalSource[] | null;
  athleteName?: string | null;
  athleteSlug?: string | null;
  fromDate?: any | null;
  sourceTypes?: AiClipperSourceType[] | null;
  statuses?: AiClipCandidateStatus[] | null;
  toDate?: any | null;
}

export interface AiClipperPostAutoGenerationConfigInput {
  burnSubtitles: boolean;
  minDurationMs: number;
  mode: string;
  numClips: number;
}

export interface AiClipperPostAutoGenerationSettingInput {
  config?: AiClipperPostAutoGenerationConfigInput | null;
  isEnabled?: boolean | null;
}

export interface AiClipperUserAccessListInput {
  isEnabled?: boolean | null;
  limit?: number | null;
  offset?: number | null;
  query?: string | null;
}

export interface AllHashtagsFilterInput {
  direction?: SortDirection | null;
  generalOnly?: boolean | null;
  hashtagNames?: string[] | null;
  keyword?: string | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: HashtagsFilterOrderBy | null;
  sportIds?: number[] | null;
}

export interface AmaFilterInput {
  daysToResponse?: FromToFilter | null;
  direction?: SortDirection | null;
  hashtagIds?: number[] | null;
  id?: string | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: AmaOrderBy | null;
  price?: FromToFilter | null;
  sports?: number[] | null;
  status?: AmaStatus | null;
  storeId?: string | null;
  storeIds?: string[] | null;
  storeName?: string | null;
  storeStatus?: StoreStatus | null;
}

export interface AmaItemCreateInput {
  daysToResponse: number;
  requestedPrice: number;
  status: AmaStatus;
  type: AmaType;
}

export interface AmaItemEditInput {
  daysToResponse: number;
  id?: string | null;
  requestedPrice: number;
  status: AmaStatus;
  type: AmaType;
}

export interface AmaRequestCreatePresignedUrlInput {
  id: string;
}

export interface AmaRequestDeclineInput {
  declineReason: string;
  id: string;
}

export interface AmaRequestFilterInput {
  customerId?: string | null;
  direction?: SortDirection | null;
  id?: string | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: AmaRequestOrderBy | null;
  orderStatus?: AmaOrderStatus[] | null;
  storeId?: string | null;
}

export interface AmaRequestQueryInput {
  createdAtDateRange?: FromToDatesFilter | null;
  customerId: string;
  direction?: SortDirection | null;
  email?: string | null;
  firstName?: string | null;
  instructions?: string | null;
  lastName?: string | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: AmaRequestOrderByFilter | null;
  orderStatus?: AmaOrderStatus[] | null;
}

export interface AmaRequestSubmitVideoInput {
  id: string;
  videoKey: string;
}

export interface AmaVideoInput {
  area: VideoCroppedArea;
  type?: string | null;
  videoKey: string;
}

export interface AppearanceStreamRecordInput {
  key: string;
}

export interface AppearanceTaskDetailsInput {
  accommodationIncluded?: boolean | null;
  appearanceDate: any;
  appearanceType?: CampaignAppearanceType | null;
  durationText?: string | null;
  location?: string | null;
  maxExpenses?: number | null;
  travelIncluded?: boolean | null;
}

export interface ApproveCampaignInput {
  id: string;
  lockEnabled?: boolean | null;
}

export interface ApproveCbTaskExtensionInput {
  extensionRequestId: string;
  offerId: string;
}

export interface ApproveDeliverableInput {
  deliverableId: string;
  offerId: string;
  ownerId?: string | null;
}

export interface ApproveMerchDesignByManagerInput {
  designRequestId: string;
}

export interface ApproveSocialBoostCampaignInput {
  id: string;
  lockEnabled?: boolean | null;
  pricePerShare: number;
}

export interface ApproveTicketZeroTaxInput {
  expectedVersion: number;
  ticketEventId: string;
}

export interface AreaOfInfluenceFilterInput {
  direction?: SortDirection | null;
  keyword?: string | null;
  limit?: number | null;
  names?: string[] | null;
  offset?: number | null;
  orderBy?: UserAreaOfInfluenceOrderBy | null;
}

export interface ArticleFilterInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: ArticleOrderBy | null;
  statuses?: ArticleStatus[] | null;
}

export interface AssessmentRangeInput {
  from?: number | null;
  to?: number | null;
}

export interface AssignInterviewAdminInput {
  id: string;
  interviewerId: string;
}

export interface AthleteStoryInputType {
  description?: string | null;
  id?: string | null;
  image?: any | null;
  link: string;
  orderIndex: number;
  publishedDate: any;
  storeId: string;
  title: string;
}

export interface AttachThankYouVideoInput {
  orderId: string;
  productType: ProductTypesType;
  storeId?: string | null;
  video: any;
}

export interface AttachThankYouVideoStreamInput {
  storeId?: string | null;
  streamId: string;
  video: any;
}

export interface AttachThankYouVideoTemplateInput {
  orderId: string;
  productType: ProductTypesType;
  storeId?: string | null;
  thankYouVideoId: string;
}

export interface AttachThankYouVideoTemplateStreamInput {
  storeId?: string | null;
  streamId: string;
  thankYouVideoId: string;
}

export interface AuctionFilterInput {
  auctionIds?: string[] | null;
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: string | null;
  scheduleDate?: FromToDatesFilter | null;
  status?: AuctionStatus[] | null;
  storeName?: string | null;
  title?: string | null;
}

export interface AuctionFromToInput {
  onAuctionFrom: any;
  onAuctionTo: any;
}

export interface AudienceFiltersInput {
  ageRanges?: AudienceAgeRange[] | null;
  ethnicities?: AudienceEthnicity[] | null;
  gender?: AudienceGender | null;
  interests?: AudienceInterest[] | null;
  languages?: string[] | null;
  locations?: CampaignLocationInput[] | null;
}

export interface AvailableSlotsDateRangeInput {
  from: any;
  to: any;
}

export interface BannerInputType {
  buttonContent?: string | null;
  buttonLink?: string | null;
  content?: string | null;
  isBannerVisible?: boolean | null;
  link?: string | null;
  linkContent?: string | null;
  mediaId: string;
  mediaType?: BannerMediaType | null;
  orderIndex: number;
  shouldLinkRedirect?: boolean | null;
  title?: string | null;
}

export interface BookInterviewSlotInput {
  guestNotes?: string | null;
  guestTimezone?: string | null;
  interviewId: string;
  interviewerId?: string | null;
  startDateUtc: any;
}

export interface BookMeActivityInput {
  custom?: CustomActivityInput | null;
  inPersonAppearance?: InPersonActivityInput | null;
  social?: SocialActivityInput | null;
  type: CampaignActivityType;
  virtualAppearance?: VirtualAppearanceActivityInput | null;
}

export interface CampaignExampleFileInput {
  key: string;
}

export interface CampaignLocationInput {
  city?: string | null;
  country: string;
  latitude?: number | null;
  longitude?: number | null;
  placeId?: string | null;
  placeText?: string | null;
  radius?: number | null;
  state?: string | null;
}

export interface CampaignOfferSubmissionInput {
  imageKey?: string | null;
  link?: string | null;
  platformMediaId?: string | null;
  taskId?: string | null;
  type: CampaignTaskType;
}

export interface CampaignPayoutInput {
  cpmRate?: number | null;
  model: CampaignPayoutModel;
}

export interface CampaignStartSettingInput {
  mode: CampaignStartMode;
  startAt?: any | null;
}

export interface CancelBidInput {
  bidId: string;
}

export interface CancelCbSubscriptionDowngradeInput {
  ownerId?: string | null;
}

export interface CancelCbSubscriptionInput {
  ownerId?: string | null;
}

export interface CancelInterviewAdminInput {
  id: string;
}

export interface CancelInterviewInput {
  id: string;
}

export interface CbApplicationAnswersInput {
  answer: string;
  questionId: string;
}

export interface CbApplicationQuestionInput {
  isRequired?: boolean | null;
  question: string;
}

export interface CbCompanyPreferencesEditInput {
  audience?: AudienceFiltersInput | null;
  budgetRanges?: CbCompanyBudgetRange[] | null;
  marketingChannels?: MarketingChannel[] | null;
  ownerId?: string | null;
  perTalentBudgetRanges?: CbTalentBudgetRange[] | null;
  smPlatforms?: CampaignSmPlatform[] | null;
  sports?: string[] | null;
}

export interface CbCreditFreeInput {
  creditAmount: number;
}

export interface CbCreditMatchInput {
  matchPercent: number;
  maxPromoPerRedemption?: number | null;
}

export interface CbPromoCodeTargetInput {
  product: SubProductSubType;
  recurrence?: SubRecurringInterval | null;
}

export interface CbSubscriptionDiscountInput {
  applicableTargets?: CbPromoCodeTargetInput[] | null;
  duration: CbDiscountDuration;
  durationMonths?: number | null;
  percentOff: number;
}

export interface CbSubscriptionTrialInput {
  applicableTargets?: CbPromoCodeTargetInput[] | null;
  trialDays: number;
}

export interface ChangePasswordInput {
  newPassword: string;
  oldPassword?: string | null;
}

export interface ChannelMonetizationMilestoneTargetInput {
  displayOrder?: number | null;
  enabled?: boolean | null;
  target: number;
  type: ChannelMonetizationMilestoneType;
}

export interface CheckEmailAvailabilityInput {
  email: string;
  ownerId?: string | null;
}

export interface CheckUsernameAvailabilityInput {
  ownerId?: string | null;
  username: string;
}

export interface ClaimSocialBoostOfferInput {
  offerId: string;
}

export interface CompleteCampaignInput {
  id: string;
  ownerId?: string | null;
}

export interface CompleteCampaignOfferInput {
  offerId: string;
  ownerId?: string | null;
}

export interface CompleteInterviewAdminInput {
  id: string;
  streamId: string;
}

export interface CompleteMultipartUploadInput {
  fileId: string;
  fileKey: string;
  parts: CompleteMultipartUploadPartInput[];
}

export interface CompleteMultipartUploadPartInput {
  ETag: string;
  PartNumber: number;
}

export interface CpmPayoutSettingDetailsInput {
  agencyId?: string | null;
  enabled: boolean;
}

export interface CreateAddressInput {
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  company?: string | null;
  country?: string | null;
  countryCode: string;
  email?: string | null;
  firstName?: string | null;
  isDefault?: boolean | null;
  lastName?: string | null;
  phone?: string | null;
  phoneNumberE164?: string | null;
  state?: string | null;
  stateCode?: string | null;
  userId?: string | null;
  zipCode: string;
}

export interface CreateAdminInput {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string | null;
}

export interface CreateAffiliateProductInput {
  imageKey: string;
  price: number;
  title: string;
  url: string;
}

export interface CreateArticleInput {
  articleUrl?: string | null;
  content: string;
  hashtagInputs: HashtagInput[];
  image: CreateImageCoverInput;
  mentionsInputs?: CreateMentionInput[] | null;
  storeIds: string[];
  title: string;
  type: ArticleTypes;
}

export interface CreateArticlePresignedUrlInput {
  contentType: string;
  ext: string;
}

export interface CreateBulkImagePostAdminInput {
  athleteName?: string | null;
  body?: string | null;
  buyProductLink?: string | null;
  description?: string | null;
  email: string;
  hashtagInputs?: HashtagInput[] | null;
  image: CreateBulkPostImageInput;
  mentionsInputs?: CreateMentionInput[] | null;
  originalMediaUrl?: string | null;
  scheduled?: ScheduleDateInput | null;
  scheduledV2?: ScheduledPostDateV2Input | null;
  title: string;
}

export interface CreateBulkPostImageInput {
  key: string;
}

export interface CreateBulkUploadInput {
  images: CreateBulkImagePostAdminInput[];
  videos: CreateBulkVideoPostAdminInput[];
}

export interface CreateBulkVideoPostAdminInput {
  athleteName?: string | null;
  body?: string | null;
  buyProductLink?: string | null;
  description: string;
  email: string;
  hashtagInputs?: HashtagInput[] | null;
  mentionsInputs?: CreateMentionInput[] | null;
  originalMediaUrl?: string | null;
  scheduled?: ScheduleDateInput | null;
  scheduledV2?: ScheduledPostDateV2Input | null;
  thumbnailKey: string;
  title: string;
  video: CreatePostVideoInputBulk;
}

export interface CreateCampaignCollabInviteInput {
  campaignId: string;
  roleId: string;
}

export interface CreateCampaignContentItemInput {
  customCaption?: string | null;
  description?: string | null;
  mediaType: CampaignMediaType;
  title: string;
  type: CampaignTaskType;
}

export interface CreateCampaignContentTaskInput {
  contentCbDisplayPeriod?: CbDisplayPeriod | null;
  contentDueDateType?: CbDueDateType | null;
  contentFixedDate?: any | null;
  contentFixedDateType?: CbFixedDateType | null;
  contentRangeFrom?: any | null;
  contentRangeTo?: any | null;
  contentValueInterval?: number | null;
  customCaption?: string | null;
  description?: string | null;
  mediaType: CampaignMediaType;
  title: string;
  type: CampaignTaskType;
}

export interface CreateCampaignDetailsInput {
  applicationDeadlineDays?: number | null;
  applicationDeadlineEnabled?: boolean | null;
  avoid?: string | null;
  brandName?: string | null;
  dueDate?: any | null;
  encouraged?: string | null;
  exampleFiles?: CampaignExampleFileInput[] | null;
  hashtags?: string[] | null;
  instructions?: string | null;
  internalName?: string | null;
  linkBio?: boolean | null;
  linkBioDurationDays?: number | null;
  mediaType?: CampaignMediaType[] | null;
  name?: string | null;
  physicalProduct?: boolean | null;
  physicalProductType?: string | null;
  pinnedPost?: boolean | null;
  pinnedPostDurationDays?: number | null;
  productName?: string | null;
  productValue?: number | null;
  profileMentions?: string | null;
  promoCodes?: string[] | null;
  promoUrls?: string[] | null;
  quantityInstructions?: string | null;
  questions?: CbApplicationQuestionInput[] | null;
  scriptUrl?: string | null;
  suggestedCaption?: string | null;
  tasks?: CreateCampaignTaskInput[] | null;
  tasksV2?: CreateCampaignTaskV2Input[] | null;
  usageRights?: boolean | null;
  usageRightsText?: string | null;
  website?: string | null;
}

export interface CreateCampaignExampleFileInput {
  name: string;
}

export interface CreateCampaignExampleFilesInput {
  files: CreateCampaignExampleFileInput[];
}

export interface CreateCampaignSubmissionFileInput {
  name: string;
}

export interface CreateCampaignSubmissionFilesInput {
  files: CreateCampaignSubmissionFileInput[];
  offerId: string;
}

export interface CreateCampaignTaskInput {
  description?: string | null;
  mediaType?: CampaignMediaType | null;
  title?: string | null;
  type: CampaignTaskType;
}

export interface CreateCampaignTaskV2Input {
  appearance?: AppearanceTaskDetailsInput | null;
  contentCbDisplayPeriod?: CbDisplayPeriod | null;
  contentDueDateType?: CbDueDateType | null;
  contentFixedDate?: any | null;
  contentItems?: CreateCampaignContentItemInput[] | null;
  contentValueInterval?: number | null;
  description?: string | null;
  examples?: CampaignExampleFileInput[] | null;
  hashtags?: string[] | null;
  mentions?: string[] | null;
  postDisplayPeriod?: CbDisplayPeriod | null;
  postDueDateType?: CbDueDateType | null;
  postFixedDate?: any | null;
  postFixedDateType?: CbFixedDateType | null;
  postRangeFrom?: any | null;
  postRangeTo?: any | null;
  postValueInterval?: number | null;
  suggestedCaption?: string | null;
  tagAsCollab?: boolean | null;
  title?: string | null;
  type: CampaignTaskType;
}

export interface CreateCbPromoCodeInput {
  code?: string | null;
  creditFree?: CbCreditFreeInput | null;
  creditMatch?: CbCreditMatchInput | null;
  expiresAt?: any | null;
  isActive?: boolean | null;
  kind: CbPromoCodeKind;
  note?: string | null;
  perAccountLimit?: number | null;
  startsAt?: any | null;
  subscriptionDiscount?: CbSubscriptionDiscountInput | null;
  subscriptionTrial?: CbSubscriptionTrialInput | null;
  totalUses?: number | null;
}

export interface CreateChannelMonetizationProgramInput {
  cloneFromMonthLabel?: string | null;
  monthLabel: string;
  prizeAmount: number;
  prizeCurrency?: string | null;
  slotsPerMonth?: number | null;
}

export interface CreateCustomInterviewNowNotificationInput {
  followingUserIds?: string[] | null;
  locations?: LocationInput[] | null;
  overrideSnooze?: boolean | null;
  overrideUnsubscribe?: boolean | null;
  questions?: CustomQuestionInput[] | null;
  sportNames: string[];
  targetUserIds?: string[] | null;
}

export interface CreateDeliverableFileInput {
  name: string;
}

export interface CreateDeliverableFilesInput {
  files: CreateDeliverableFileInput[];
}

export interface CreateDesignImageExamplePresignedUrlInput {
  numberOfImages: number;
}

export interface CreateDesignImagePresignedUrl {
  designRequestId: string;
  numberOfImages: number;
}

export interface CreateEditedVideoInput {
  key: string;
}

export interface CreateExperienceImagePresignedUrlInput {
  numberOfImages: number;
}

export interface CreateExperienceInput {
  comment?: string | null;
  description?: string | null;
  hashtagInputs?: HashtagInput[] | null;
  images: ExperienceImageInput[];
  numberOfUnits?: number | null;
  requestedPrice: number;
  storeId: string;
  title: string;
}

export interface CreateImageCoverInput {
  imageLabel: string;
  key: string;
}

export interface CreateImagePostAdminInput {
  body?: string | null;
  buyProductLink?: string | null;
  hashtagInputs?: HashtagInput[] | null;
  image: CreatePostImageInput;
  mentionsInputs?: CreateMentionInput[] | null;
  scheduled?: ScheduleDateInput | null;
  scheduledV2?: ScheduledPostDateV2Input | null;
  storeId: string;
  title: string;
}

export interface CreateMatchupCompetitorInput {
  corner: MatchupCorner;
  inviteToken?: string | null;
  invitedEmail?: string | null;
  invitedPhone?: string | null;
  name?: string | null;
  storeId?: string | null;
}

export interface CreateMatchupInput {
  category?: string | null;
  competitors: CreateMatchupCompetitorInput[];
  id?: string | null;
  isMainEvent?: boolean | null;
  order?: number | null;
  roundMinutes?: number | null;
  rounds?: number | null;
}

export interface CreateMemorabiliaImagePresignedUrl {
  numberOfImages: number;
}

export interface CreateMemorabiliaInput {
  addressId?: string | null;
  auctionDateRange?: AuctionFromToInput | null;
  comment?: string | null;
  customsDescription?: string | null;
  description?: string | null;
  fulfillment: MemorabiliaFulfillment;
  hashtagInputs?: HashtagInput[] | null;
  height?: number | null;
  images: MemorabiliaImageInput[];
  length?: number | null;
  memorabiliaProductType: MemorabiliaProductType;
  numberOfUnits: number;
  requestedPrice: number;
  shipmentCategory: string;
  storeId: string;
  title: string;
  weight?: number | null;
  width?: number | null;
}

export interface CreateMentionInput {
  storeId?: string | null;
  unregisteredContactId?: string | null;
}

export interface CreateMerchDesignLogoInput {
  key: string;
}

export interface CreateMerchImagePresignedUrl {
  numberOfImages: number;
}

export interface CreateMerchProductV2AdminInput {
  creationSource?: MerchCreationSource | null;
  customImageSets?: MerchProductCustomImageSetInput[] | null;
  designRequestId?: string | null;
  finalMerchStatus?: MerchProductStatus | null;
  hashtagInputs?: HashtagInput[] | null;
  printFileSets: MerchProductPrintFileSetInput[];
  requestedProfit: number;
  storeId: string;
  title: string;
  type: MerchType;
  variantSets: MerchProductVariantSet[];
}

export interface CreatePastAppearanceStreamInput {
  ownerId?: string | null;
  stream: PastAppearanceStreamInput;
  submissionId: string;
}

export interface CreatePayoutOrderInput {
  amount: number;
  currency: string;
  payouts?: UserPayoutInput[] | null;
  periodFrom: any;
  periodTo: any;
  storeId: string;
}

export interface CreatePostImageInput {
  key: string;
}

export interface CreatePostImagePresignedUrlV2FileInput {
  contentType: string;
  ext: string;
}

export interface CreatePostVideoInput {
  key: string;
}

export interface CreatePostVideoInputBulk {
  key: string;
}

export interface CreatePresignedAffiliateProductImageUrlsInput {
  numberOfImages: number;
}

export interface CreatePresignedAiClipperChannelLogoUrlInput {
  contentType: string;
}

export interface CreatePromocodeInput {
  amaIds?: string[] | null;
  amount: number;
  chargeSubject: PromoCodesChargeSubject;
  endDate?: any | null;
  endUtc?: any | null;
  isSiteWide?: boolean | null;
  merchProductIds?: string[] | null;
  name: string;
  perUserLimit: number;
  siteWideOptions?: ProductTypesType[] | null;
  startDate?: any | null;
  startUtc?: any | null;
  streamIds?: string[] | null;
  ticketEventIds?: string[] | null;
  timeZone?: TimeZoneInput | null;
  tz?: string | null;
  usageLimit: number;
}

export interface CreateRedirectInput {
  from: string;
  to: string;
}

export interface CreateStoreExampleImageInput {
  key: string;
}

export interface CreateStreamAdminInput {
  affiliateCommissionPercent?: number | null;
  affiliateEnabled?: boolean | null;
  affiliateProducts?: CreateAffiliateProductInput[] | null;
  chatEnabled?: boolean | null;
  description: string;
  fanPollingEnabled?: boolean | null;
  hashtagInputs?: HashtagInput[] | null;
  image?: any | null;
  imageFileKey?: string | null;
  isFree?: boolean | null;
  isHidden?: boolean | null;
  isPPV?: boolean | null;
  matchups?: CreateMatchupInput[] | null;
  mentionsInputs?: CreateMentionInput[] | null;
  moderatorId?: string | null;
  name?: string | null;
  participantIds?: string[] | null;
  postEventContentHubEnabled?: boolean | null;
  price?: number | null;
  repeatingTitle?: string | null;
  repeatsEveryEnum?: StreamIntervalEnum | null;
  requestedPrice?: number | null;
  scheduleDate?: any | null;
  scheduleDateV2?: DateV2Input | null;
  sharePickGraphicsEnabled?: boolean | null;
  sponsors?: StreamCreateSponsorsInput[] | null;
  sportIds?: number[] | null;
  storeId: string;
  timeZone?: TimeZoneInput | null;
}

export interface CreateStreamClipInput {
  endTs: number;
  startTs: number;
  streamRecordId: number;
  title?: string | null;
}

export interface CreateStreamImageAdminInput {
  files: StreamImageItemInput[];
  storeId: string;
}

export interface CreateStreamImageInput {
  files: StreamImageItemInput[];
}

export interface CreateTalentInviteLinkAllDealsInput {
  ownerId?: string | null;
}

export interface CreateTalentInviteLinkForCampaignInput {
  campaignId: string;
}

export interface CreateThankYouVideoTemplateInput {
  productType: ProductTypesType;
  storeId?: string | null;
  video: any;
}

export interface CreateTicketEventInput {
  admissionClosesAt?: any | null;
  affiliateCommissionPercent?: number | null;
  affiliateEnabled?: boolean | null;
  coverImageFileKey?: string | null;
  description?: string | null;
  doorsOpenAt?: any | null;
  endsAt?: any | null;
  entryRequirements?: string | null;
  fanPollingEnabled?: boolean | null;
  hashtagInputs?: HashtagInput[] | null;
  leagueId?: string | null;
  matchups?: CreateMatchupInput[] | null;
  maxAdmissions?: number | null;
  minimumAge?: number | null;
  name?: string | null;
  ownerId?: string | null;
  promotion?: string | null;
  refundPolicy?: string | null;
  repeatsEvery?: StreamIntervalEnum | null;
  salesCloseAt?: any | null;
  salesOpenAt?: any | null;
  sportIds?: number[] | null;
  startsAt?: any | null;
  streamId?: string | null;
  termsAndConditions?: string | null;
  ticketsEnabled?: boolean | null;
  tiers?: TicketTierDetailsInput[] | null;
  venue?: TicketVenueDetailsInput | null;
  venueId?: string | null;
}

export interface CreateTicketPresaleCodeInput {
  code: string;
  endsAt: any;
  label: string;
  maxUses?: number | null;
  startsAt: any;
  ticketEventId: string;
  tierId?: string | null;
}

export interface CreateTicketVenueInput {
  addressLine1: string;
  addressLine2?: string | null;
  city: string;
  country: string;
  latitude: number;
  longitude: number;
  name: string;
  ownerId?: string | null;
  postalCode: string;
  region: string;
  timezone: string;
}

export interface CreateTransitionInput {
  isActive?: boolean | null;
  name: string;
  type?: TransitionType | null;
  videoKey: string;
}

export interface CreateUnregisteredContactInput {
  email?: string | null;
  name?: string | null;
  phoneNumberE164?: string | null;
  representativeName?: string | null;
  socialMediaLink?: string | null;
  type: ContactType;
  url?: string | null;
}

export interface CreateUserAvatarUrlInput {
  contentType: string;
  ext: string;
}

export interface CreateVariantPrintfilePresignedUrlsInput {
  files: VariantPrintfilePresignedUrlInput[];
}

export interface CreateVideoEditThumbnailImagePresignedUrlV2FileInput {
  contentType: string;
  ext: string;
}

export interface CreateVideoEditThumbnailImagePresignedUrlV2Input {
  files: CreateVideoEditThumbnailImagePresignedUrlV2FileInput[];
}

export interface CreateVideoPostAdminInput {
  body?: string | null;
  buyProductLink?: string | null;
  hashtagInputs?: HashtagInput[] | null;
  mentionsInputs?: CreateMentionInput[] | null;
  scheduled?: ScheduleDateInput | null;
  scheduledV2?: ScheduledPostDateV2Input | null;
  storeId: string;
  thumbnailKey?: string | null;
  title: string;
  video: CreatePostVideoInput;
}

export interface CustomActivityInput {
  files?: CampaignExampleFileInput[] | null;
  instructions?: string | null;
}

export interface CustomBriefActivityDetailsInput {
  avoid?: string | null;
  brandName?: string | null;
  contracts?: CampaignExampleFileInput[] | null;
  encouraged?: string | null;
  instructions?: string | null;
  products?: CustomBriefProductInput[] | null;
  promoCodes?: string[] | null;
  promoUrls?: string[] | null;
  tasksV2?: CreateCampaignTaskV2Input[] | null;
  website?: string | null;
}

export interface CustomBriefActivityInput {
  customBrief?: CustomBriefActivityDetailsInput | null;
  type?: CampaignActivityType | null;
}

export interface CustomBriefProductInput {
  cost: number;
  description?: string | null;
  name: string;
  qty: number;
  shipping?: boolean | null;
}

export interface CustomPlatformCriteriaInput {
  engagementRateRange?: FromToFilter | null;
  followersRange?: FromToFilter | null;
  platform: CampaignSmPlatform;
}

export interface CustomQuestionInput {
  question: string;
  topic: string;
  topicGroup: InterviewQuestionTopic;
}

export interface DashboardFilter {
  from?: any | null;
  storeId?: string | null;
  to?: any | null;
}

export interface DateV2Input {
  tz?: string | null;
  utc: any;
}

export interface DeactivateTalentInviteLinkInput {
  linkId: string;
}

export interface DeclareTicketEventMatchupWinnerInput {
  matchupId: string;
  ticketEventId: string;
  winnerCorner?: MatchupCorner | null;
}

export interface DeclineCampaignInput {
  id: string;
  returnToAccountBalance?: boolean | null;
}

export interface DeclineSocialBoostOfferInput {
  offerId: string;
}

export interface DeleteBrandProductCategoryInput {
  id: string;
  transferToCategoryId?: string | null;
}

export interface DeleteBrandRestrictedCategoryInput {
  id: string;
  transferToCategoryId?: string | null;
}

export interface DeleteCampaignInput {
  campaignId: string;
}

export interface DeleteEditedVideoInput {
  editedVideoId: string;
  key?: string | null;
}

export interface DeleteExperienceInput {
  id: string;
}

export interface DeleteInappropriateMarkInput {
  id: string;
}

export interface DeleteMediaPostAdminInput {
  id: string;
  storeId: string;
}

export interface DeleteMemorabiliaInput {
  id: string;
  permanent?: boolean | null;
  storeId?: string | null;
}

export interface DeleteRedirectInput {
  id: string;
}

export interface DeleteStreamClipInput {
  id: string;
}

export interface DeleteStreamInput {
  id: string;
}

export interface DeleteThankYouVideoTemplateInput {
  storeId?: string | null;
  thankYouVideoId: string;
}

export interface DeliverableFileInput {
  key: string;
  name: string;
}

export interface DeliverableItemInput {
  copy?: string | null;
  key?: string | null;
  name?: string | null;
  taskId: string;
  type: CBDeliverableItemType;
  videoTranscodingJobId?: string | null;
}

export interface DeliverableReviewItemInput {
  action: DeliverableReviewAction;
  deliverableItemId: string;
  feedback?: string | null;
}

export interface DeliverableRevisionLimitSettingDetailsInput {
  revisionLimit: number;
}

export interface DesignMerchChangePriorityInput {
  designPriorityType: DesignPriorityType;
  designRequestId: string;
}

export interface DesignRequestsFilterInput {
  designRequestId?: string | null;
  designRequestIds?: string[] | null;
  designRequestStatuses?: DesignRequestStatus[] | null;
  designRequestType?: DesignRequestType | null;
  designRequestTypes?: DesignRequestType[] | null;
  designerIds?: string[] | null;
  designerName?: string | null;
  direction?: SortDirection | null;
  escalatedToId?: string | null;
  isAwaitingAthleteApproval?: boolean | null;
  isInProgress?: boolean | null;
  isOverdue?: boolean | null;
  isUnassigned?: boolean | null;
  limit?: number | null;
  managedById?: string | null;
  offset?: number | null;
  orderBy?: DesignRequestsOrderBy | null;
  storeIds?: string[] | null;
  storeName?: string | null;
}

export interface DesignStyleSettingsInput {
  abstractLiteral?: number | null;
  classicModern?: number | null;
  economicalLuxurious?: number | null;
  feminineMasculine?: number | null;
  geometricOrganic?: number | null;
  matureYouthful?: number | null;
  playfulSophisticated?: number | null;
}

export interface DesignerCreateInput {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string | null;
  socialMediaLink?: string | null;
}

export interface DesignerDetailsEditInput {
  isIncludedInAutoAssignment?: boolean | null;
}

export interface DesignerEditInput {
  designerDetails?: DesignerDetailsEditInput | null;
  designerId?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  password?: string | null;
  phoneNumber?: string | null;
  socialMediaLink?: string | null;
}

export interface DesignersFilterInput {
  designRequestStatuses?: DesignRequestStatus[] | null;
  designerIds?: string[] | null;
  designerName?: string | null;
  designerStatus?: DesignerStatus[] | null;
  direction?: SortDirection | null;
  email?: string | null;
  hasActiveDesignRequests?: boolean | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: DesignersOrderBy | null;
}

export interface DigitalAgreementSettingDetailsInput {
  campaignType?: CampaignType | null;
  enabled: boolean;
}

export interface DownloadCampaignOffersFullInput {
  campaignId: string;
}

export interface DuplicateCampaignInput {
  campaignId: string;
  ownerId?: string | null;
}

export interface EarthCoordinateInput {
  latitude: number;
  longitude: number;
}

export interface EditAffiliateProductInput {
  id?: string | null;
  imageKey: string;
  price: number;
  title: string;
  url: string;
}

/**
 * Wording-only edits; omitted fields are left unchanged, null clears a field unless it cannot be cleared
 */
export interface EditCampaignContentInput {
  avoid?: string | null;
  brandName?: string | null;
  campaignId: string;
  encouraged?: string | null;
  instructions?: string | null;
  promoCodes?: string[] | null;
  promoUrls?: string[] | null;
  tasks?: EditCampaignTaskContentInput[] | null;
  website?: string | null;
}

export interface EditCampaignSettingsInput {
  campaignId: string;
  internalName?: string | null;
  inviteNotificationsEnabled?: boolean | null;
  inviteProcessingFee?: number | null;
  launchFee?: number | null;
  maxBudget?: number | null;
  platformMarginPercent?: number | null;
  requiresAgreement?: boolean | null;
  startSetting?: CampaignStartSettingInput | null;
}

export interface EditCampaignTaskContentInput {
  description?: string | null;
  hashtags?: string[] | null;
  id: string;
  mentions?: string[] | null;
  suggestedCaption?: string | null;
  tagAsCollab?: boolean | null;
  title?: string | null;
}

export interface EditEditedVideoInput {
  body?: string | null;
  durationMs?: number | null;
  editedVideoId: string;
  hashtagInputs?: HashtagInput[] | null;
  key?: string | null;
  mentionsInputs?: CreateMentionInput[] | null;
  thumbnailKey?: string | null;
  title?: string | null;
}

export interface EditHashtagInput {
  id: number;
  name?: string | null;
  sportIds?: number[] | null;
}

export interface EditImagePostAdminInput {
  body?: string | null;
  buyProductLink?: string | null;
  hashtagInputs?: HashtagInput[] | null;
  id: string;
  image: EditPostImageInput;
  mentionsInputs?: CreateMentionInput[] | null;
  scheduled?: ScheduleDateInput | null;
  scheduledV2?: ScheduledPostDateV2Input | null;
  storeId: string;
  title: string;
}

export interface EditInterviewerDetailsInput {
  scheduleLink?: string | null;
}

export interface EditKeywordInput {
  id: string;
  name?: string | null;
}

export interface EditMerchProductV2AdminInput {
  customImageSets?: MerchProductCustomImageSetInput[] | null;
  finalMerchStatus?: MerchProductStatus | null;
  hashtagInputs?: HashtagInput[] | null;
  id: number;
  printFileSets?: MerchProductPrintFileSetInput[] | null;
  requestedProfit: number;
  storeId: string;
  title: string;
  type: MerchType;
  variantSets?: MerchProductVariantSet[] | null;
}

export interface EditPostImageInput {
  id?: string | null;
  key?: string | null;
}

/**
 * Provide either id to keep existing video or a key to upload new video
 */
export interface EditPostVideoInput {
  id?: string | null;
  key?: string | null;
}

export interface EditRedirectInput {
  from: string;
  id: string;
  to: string;
}

export interface EditStreamAdminInput {
  affiliateCommissionPercent?: number | null;
  affiliateEnabled?: boolean | null;
  affiliateProducts?: EditAffiliateProductInput[] | null;
  chatEnabled?: boolean | null;
  description: string;
  fanPollingEnabled?: boolean | null;
  hashtagInputs?: HashtagInput[] | null;
  id: string;
  image?: any | null;
  imageFileKey?: string | null;
  isFree?: boolean | null;
  isHidden?: boolean | null;
  isPPV?: boolean | null;
  matchups?: CreateMatchupInput[] | null;
  mentionsInputs?: CreateMentionInput[] | null;
  moderatorId?: string | null;
  name?: string | null;
  participantIds?: string[] | null;
  postEventContentHubEnabled?: boolean | null;
  price?: number | null;
  repeatingTitle?: string | null;
  repeatsEveryEnum?: StreamIntervalEnum | null;
  requestedPrice?: number | null;
  scheduleDate?: any | null;
  scheduleDateV2?: DateV2Input | null;
  sharePickGraphicsEnabled?: boolean | null;
  sponsors?: StreamCreateSponsorsInput[] | null;
  sportIds?: number[] | null;
  storeId: string;
  timeZone?: TimeZoneInput | null;
}

export interface EditUserAreaOfInfluenceInput {
  id: string;
  name?: string | null;
}

export interface EditVideoPostAdminInput {
  body?: string | null;
  buyProductLink?: string | null;
  hashtagInputs?: HashtagInput[] | null;
  id: string;
  mentionsInputs?: CreateMentionInput[] | null;
  scheduled?: ScheduleDateInput | null;
  scheduledV2?: ScheduledPostDateV2Input | null;
  storeId: string;
  thumbnailKey?: string | null;
  title: string;
  video: EditPostVideoInput;
}

export interface EstimateMerchPriceInput {
  ownerId?: string | null;
  printFileSets: MerchEstimatePrintFileSetInput[];
  requestedProfit: number;
  type: MerchType;
  variantSets: MerchProductVariantSet[];
}

export interface EstimateStreamPriceInput {
  finalPrice: number;
  ownerId?: string | null;
}

export interface EventMarketingActivityInput {
  description?: string | null;
  participantCount?: number | null;
  socialMediaLinks?: string[] | null;
  sport?: string | null;
  startDate?: any | null;
}

export interface EventMarketingCampaignActivityInput {
  eventMarketing?: EventMarketingActivityInput | null;
  type: CampaignActivityType;
}

export interface ExperienceFilterInput {
  description?: string | null;
  direction?: SortDirection | null;
  id?: string | null;
  isOrphanPage?: boolean | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: ExperienceOrderBy | null;
  price?: FromToFilter | null;
  searchTerm?: string | null;
  sports?: number[] | null;
  statuses?: ExperienceStatus[] | null;
  storeIds?: string[] | null;
  storeName?: string | null;
  storeSlug?: string | null;
  storeStatuses?: StoreStatus[] | null;
  title?: string | null;
}

export interface ExperienceImageInput {
  experienceImageFileKey: string;
  isMainImage?: boolean | null;
}

export interface ExperiencePriceEstimateInput {
  ownerId?: string | null;
  requestedPrice: number;
}

export interface ExperienceSalesInput {
  createdAtDateRange?: FromToDatesFilter | null;
  customerEmail?: string | null;
  customerName?: string | null;
  direction?: SortDirection | null;
  experienceId?: string | null;
  id?: string | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: ExperienceSalesOrderBy | null;
  statuses?: ExperienceRequestStatus[] | null;
  storeId?: string | null;
  storeName?: string | null;
  title?: string | null;
}

export interface ExportExtTalentsInput {
  columns?: ExtTalentExportColumn[] | null;
  filters?: ExtTalentExportFiltersInput | null;
}

export interface ExtTalentContactFilterInput {
  role?: ExtTalentContactRole | null;
  type?: ExtTalentContactType | null;
  value: string;
}

export interface ExtTalentExportFiltersInput {
  athleticLevels?: ExtTalentAthleticLevel[] | null;
  avgEngagement?: FromToFilter | null;
  bioHashtags?: string | null;
  birthYear?: FromToFilter | null;
  collegeUniversity?: string | null;
  contact?: ExtTalentContactFilterInput | null;
  extTalentIds?: string[] | null;
  followersCount?: FromToFilter | null;
  genders?: StoreGender[] | null;
  hasEmail?: boolean | null;
  homeLocations?: ExtTalentLocationInput[] | null;
  isOnPlatform?: boolean | null;
  league?: string | null;
  locations?: ExtTalentLocationInput[] | null;
  name?: string | null;
  profileName?: string | null;
  query?: string | null;
  socialHandle?: string | null;
  socialPlatform?: ExtTalentSocialPlatform | null;
  sports?: string[] | null;
  team?: string | null;
}

export interface ExtTalentLocationInput {
  city?: string | null;
  country?: string | null;
  state?: string | null;
}

export interface FeaturedPpvEventInput {
  orderIndex: number;
  streamId: string;
}

export interface FeeSettingDetailsInput {
  campaignType?: CampaignType | null;
  launchFee: number;
}

export interface FromToDatesFilter {
  from?: any | null;
  to?: any | null;
}

export interface FromToDatesStrictFilter {
  from: any;
  to: any;
}

export interface FromToFilter {
  from?: number | null;
  to?: number | null;
}

export interface GeneralSettingsConfigInput {
  guestInterviewLimit: number;
  hostInterviewLimit: number;
}

export interface GetAddressesInput {
  userId: string;
}

export interface GetAdminMerchProductsInput {
  color?: MerchProductColor[] | null;
  createdByRoles?: UserRole[] | null;
  direction?: SortDirection | null;
  gender?: Gender[] | null;
  genderV2?: GenderInputFilter[] | null;
  ids?: number[] | null;
  isCreatedByAdmin?: boolean | null;
  limit?: number | null;
  merchStatus?: MerchProductStatus | null;
  offset?: number | null;
  orderBy?: MerchProductOrderBy | null;
  price?: FromToFilter | null;
  searchTerm?: string | null;
  size?: string[] | null;
  sports?: number[] | null;
  storeId?: string | null;
  storeIds?: string[] | null;
  storeName?: string | null;
  storeSlug?: string | null;
  storeStatuses?: StoreStatus | null;
  title?: string | null;
  type?: MerchType[] | null;
  withDeleted?: boolean | null;
}

export interface GetAgenciesInput {
  companyName?: string | null;
  direction?: SortDirection | null;
  email?: string | null;
  limit?: number | null;
  name?: string | null;
  offset?: number | null;
  orderBy?: AgencyListOrderBy | null;
  statuses?: StoreStatus[] | null;
}

export interface GetAgencyCreditUsageInput {
  agencyId: string;
  limit?: number | null;
  offset?: number | null;
}

export interface GetAgencyInput {
  agencyId?: string | null;
}

export interface GetAiClipperTimeSeriesInput {
  filter?: AiClipperMetricsFilterInput | null;
  granularity?: AiClipperTimeSeriesGranularity | null;
}

export interface GetAiClipperUserBreakdownInput {
  direction?: SortDirection | null;
  filter?: AiClipperMetricsFilterInput | null;
  limit?: number | null;
  offset?: number | null;
}

export interface GetAmaSalesInput {
  createdAtDateRange?: FromToDatesFilter | null;
  customerEmail?: string | null;
  customerName?: string | null;
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: AmaSalesOrderBy | null;
  storeId?: string | null;
  storeName?: string | null;
}

export interface GetAnyProductSalesInput {
  createdAtDateRange?: FromToDatesFilter | null;
  customerEmail?: string | null;
  customerId?: string | null;
  customerName?: string | null;
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: AnyProductSalesOrderBy | null;
  orderId?: string | null;
  orderIdStrict?: number | null;
  storeId?: string | null;
  subOrderStatuses?: MerchOrderStatus[] | null;
  subtotalRange?: FromToFilter | null;
  totalStoreRevenuesRange?: FromToFilter | null;
  types?: ProductSalesType[] | null;
}

export interface GetAuditLogsAdminInput {
  actions?: string[] | null;
  direction?: SortDirection | null;
  from?: any | null;
  limit?: number | null;
  performedByEmail?: string | null;
  performedById?: string | null;
  startAfter?: string | null;
  targetId?: string | null;
  to?: any | null;
  types?: AuditLogType[] | null;
}

export interface GetAvailableScheduleSlotsInput {
  dateRange: AvailableSlotsDateRangeInput;
  type?: ScheduleType | null;
  userId: string;
}

export interface GetCampaignAgreementSignatoryCandidatesInput {
  campaignId: string;
}

export interface GetCampaignInput {
  id: string;
}

export interface GetCampaignLockInput {
  id: string;
}

export interface GetCampaignOffersInput {
  ageRange?: FromToFilter | null;
  appliedAtRange?: FromToDatesFilter | null;
  approvedAtRange?: FromToDatesFilter | null;
  campaignId?: string | null;
  countries?: string[] | null;
  createdAtRange?: FromToDatesFilter | null;
  declinedAtRange?: FromToDatesFilter | null;
  direction?: SortDirection | null;
  engagementRateRange?: FromToFilter | null;
  genders?: CampaignOfferGenderFilter[] | null;
  includeInviteLinkOffers?: boolean | null;
  includeShelvedOffers?: boolean | null;
  isInviteLinkOffer?: boolean | null;
  isProductSent?: boolean | null;
  isShelved?: boolean | null;
  limit?: number | null;
  name?: string | null;
  offerIds?: string[] | null;
  offset?: number | null;
  orderBy?: CampaignOffersOrderBy | null;
  socialFollowingLiveRange?: FromToFilter | null;
  socialFollowingRange?: FromToFilter | null;
  socialMediaType?: SocialMediaType | null;
  sports?: string[] | null;
  states?: string[] | null;
  statuses?: CampaignOfferStatus[] | null;
  statusesV2?: CampaignOfferStatus[] | null;
  submittedAtRange?: FromToDatesFilter | null;
  totalFeeRange?: FromToFilter | null;
}

export interface GetCampaignsInput {
  agencyEmail?: string | null;
  agencyId?: string | null;
  agencyName?: string | null;
  brandName?: string | null;
  campaignId?: string | null;
  campaignIds?: string[] | null;
  createdAtRange?: FromToDatesFilter | null;
  direction?: SortDirection | null;
  dueDateRange?: FromToDatesFilter | null;
  internalName?: string | null;
  limit?: number | null;
  name?: string | null;
  offset?: number | null;
  orderBy?: CampaignsOrderBy | null;
  statuses?: CampaignStatus[] | null;
  talentName?: string | null;
  types?: CampaignType[] | null;
  withPhysicalProduct?: boolean | null;
}

export interface GetCbAccountBalanceInput {
  ownerId?: string | null;
}

export interface GetCbApplicationAnswersInput {
  offerId: string;
}

export interface GetCbBalanceTransactionsInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  ownerId?: string | null;
  type?: CbBalanceTransactionType | null;
}

export interface GetCbCompanyPreferencesInput {
  ownerId?: string | null;
}

export interface GetCbDeliverableVotesInput {
  deliverableId: string;
}

/**
 * Input for getting pending extension requests for an offer
 */
export interface GetCbPendingExtensionRequestsInput {
  offerId: string;
}

export interface GetCbPromoCodeRedemptionsInput {
  direction?: SortDirection | null;
  from?: any | null;
  kind?: CbPromoCodeKind | null;
  limit?: number | null;
  offset?: number | null;
  ownerId?: string | null;
  performedById?: string | null;
  promoCodeId?: string | null;
  to?: any | null;
}

export interface GetCbPromoCodesInput {
  code?: string | null;
  direction?: SortDirection | null;
  isActive?: boolean | null;
  kind?: CbPromoCodeKind | null;
  limit?: number | null;
  offset?: number | null;
}

export interface GetCbSettingsInput {
  agencyId?: string | null;
  scope: CbSettingScope;
  type?: CbSettingType | null;
}

export interface GetCbTaskExtensionHistoryInput {
  deliverableId?: string | null;
  offerId: string;
  requestId?: string | null;
}

export interface GetCbTeamInput {
  ownerId?: string | null;
}

export interface GetChannelMonetizationAdminLeaderboardInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
}

export interface GetChannelMonetizationLeaderboardContentInput {
  monthLabel: string;
  storeId: string;
}

export interface GetCounterOfferHistoryInput {
  offerId: string;
}

export interface GetCountryStatesInput {
  countryId: number;
}

export interface GetInterviewTaskInput {
  id: string;
}

export interface GetInterviewsInput {
  createdAtDateRange?: FromToDatesFilter | null;
  creationTypes?: InterviewCreationType[] | null;
  direction?: SortDirection | null;
  id?: string | null;
  intervieweeEmail?: string | null;
  intervieweeName?: string | null;
  interviewerId?: string | null;
  interviewerName?: string | null;
  limit?: number | null;
  nameSearch?: string | null;
  offset?: number | null;
  orderBy?: InterviewerTasksOrderBy | null;
  scheduleDateRange?: FromToDatesFilter | null;
  slugSearch?: string | null;
  sources?: InterviewSourceType[] | null;
  statuses?: InterviewStatus[] | null;
}

export interface GetMediaPostInput {
  id?: string | null;
  slug?: string | null;
  storeSlug?: string | null;
}

export interface GetMediaPostsInput {
  direction?: SortDirection | null;
  ids?: string[] | null;
  isOrphanPage?: boolean | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: MediaPostsOrderBy | null;
  searchTerm?: string | null;
  statuses?: MediaPostStatus[] | null;
  storeId?: string | null;
  storeSlug?: string | null;
  storeStatuses?: StoreStatus[] | null;
  type?: MediaPostType[] | null;
  withDeleted?: boolean | null;
}

export interface GetMerchProductInput {
  id?: number | null;
  slug?: string | null;
  storeSlug?: string | null;
}

export interface GetMerchProductsInput {
  color?: MerchProductColor[] | null;
  createdByRoles?: UserRole[] | null;
  direction?: SortDirection | null;
  gender?: Gender[] | null;
  genderV2?: GenderInputFilter[] | null;
  ids?: number[] | null;
  isCreatedByAdmin?: boolean | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: MerchProductOrderBy | null;
  price?: FromToFilter | null;
  searchTerm?: string | null;
  size?: string[] | null;
  sports?: number[] | null;
  storeId?: string | null;
  storeIds?: string[] | null;
  storeName?: string | null;
  storeSlug?: string | null;
  title?: string | null;
  type?: MerchType[] | null;
}

export interface GetMyCbEntitlementsInput {
  ownerId?: string | null;
}

export interface GetMyCbSubscriptionInput {
  ownerId?: string | null;
}

export interface GetMyInterviewsInput {
  createdAtDateRange?: FromToDatesFilter | null;
  direction?: SortDirection | null;
  id?: string | null;
  intervieweeEmail?: string | null;
  intervieweeName?: string | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: InterviewerTasksOrderBy | null;
  scheduleDateRange?: FromToDatesFilter | null;
  statuses?: InterviewStatus[] | null;
}

export interface GetMyInvoicesInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: GetMyInvoicesOrderBy | null;
  ownerId?: string | null;
  statuses?: InvoiceStatus[] | null;
  types?: InvoiceType[] | null;
}

export interface GetMyScheduleEventsInput {
  dateRange: FromToDatesStrictFilter;
  status?: ScheduleEventStatus[] | null;
  type?: ScheduleType | null;
}

export interface GetMyScheduleInput {
  type?: ScheduleType | null;
}

export interface GetPlaceDetailsInput {
  id: string;
  sessionToken?: string | null;
}

export interface GetPlacePredictionsInput {
  includedPrimaryTypes?: string[] | null;
  query: string;
  sessionToken?: string | null;
}

export interface GetPostAiClipCandidatesInput {
  fromDate?: any | null;
  limit?: number | null;
  offset?: number | null;
  query?: string | null;
  sourceMediaPostId?: string | null;
  statuses?: AiClipCandidateStatus[] | null;
  toDate?: any | null;
}

export interface GetPrProductsInput {
  type: MerchType;
}

export interface GetPromoCodeInput {
  amaId?: string | null;
  customerId?: string | null;
  id?: string | null;
  merchIds?: number[] | null;
  name?: string | null;
  streamId?: string | null;
}

export interface GetPromocodeStatsFilter {
  dateRange?: FromToDatesFilter | null;
  direction?: SortDirection | null;
  limit?: number | null;
  name?: string | null;
  offset?: number | null;
  orderBy?: PromocodesOrderBy | null;
  storeId?: string | null;
}

export interface GetRedirectsInput {
  direction?: SortDirection | null;
  from?: string | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: GetRedirectsOrderBy | null;
  to?: string | null;
}

export interface GetScheduleEventsInput {
  dateRange: FromToDatesStrictFilter;
  status?: ScheduleEventStatus[] | null;
  type?: ScheduleType | null;
  userId: string;
}

export interface GetScheduleInput {
  type?: ScheduleType | null;
  userId: string;
}

export interface GetSocialBoostCampaignOffersInput {
  campaignId: string;
  limit?: number | null;
  offset?: number | null;
  statuses?: CampaignOfferStatus[] | null;
}

export interface GetSocialBoostCampaignSharesInput {
  campaignId: string;
}

export interface GetSportsInput {
  name?: string | null;
  storeRoles?: UserRole[] | null;
}

export interface GetStateCitiesInput {
  direction?: SortDirection | null;
  limit?: number | null;
  name?: string | null;
  offset?: number | null;
  stateId: number;
}

export interface GetStreamClipInput {
  id: string;
}

export interface GetTalentInviteLinksForCampaignInput {
  campaignId: string;
}

export interface GetTalentInviteLinksInput {
  ownerId?: string | null;
}

export interface GetThankYouVideoTemplateInput {
  productType: ProductTypesType;
  storeId?: string | null;
}

export interface GetUnmergedMerchInput {
  direction?: SortDirection | null;
  isOrphanPage?: boolean | null;
  limit?: number | null;
  merchTitle?: string | null;
  offset?: number | null;
  orderBy?: UnmergedMerchOrderBy | null;
  storeEmail?: string | null;
  storeId?: string | null;
  storeName?: string | null;
  storeStatuses?: StoreStatus[] | null;
  types?: MerchType[] | null;
}

export interface GetUnregisteredContactsInput {
  direction?: SortDirection | null;
  email?: string | null;
  limit?: number | null;
  name?: string | null;
  offset?: number | null;
  orderBy?: UnregisteredContactOrderBy | null;
  representativeName?: string | null;
  type?: ContactType | null;
}

export interface GetVideoTranscodingJobsInput {
  ids: string[];
}

export interface HandleCounterOfferInput {
  action?: CounterOfferAction | null;
  addressId?: string | null;
  amount?: number | null;
  answers?: CbApplicationAnswersInput[] | null;
  counterProposalId?: string | null;
  message?: string | null;
  offerId?: string | null;
  payWith?: CbPaymentSource | null;
  paymentMethodId?: string | null;
}

export interface HashtagInput {
  name: string;
}

export interface HideStreamInput {
  id: string;
}

export interface HomePageDataSetupType {
  amas?: HomePageEntityString[] | null;
  athleteStories?: AthleteStoryInputType[] | null;
  ctaBanners: BannerInputType[];
  mainBanners: BannerInputType[];
  merch?: HomePageEntityNumber[] | null;
  stores?: HomePageEntityString[] | null;
  watchStreams?: HomePageEntityString[] | null;
}

export interface HomePageEntityNumber {
  id: number;
  orderIndex: number;
}

export interface HomePageEntityString {
  id: string;
  orderIndex: number;
}

export interface HometownLocationInput {
  city?: string | null;
  country: string;
  latitude?: number | null;
  longitude?: number | null;
  placeId?: string | null;
  placeText?: string | null;
  radius?: number | null;
  state?: string | null;
}

export interface HostedTicketEventInput {
  ticketEventId: string;
}

export interface HostedTicketEventsInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: HostedTicketEventsOrderBy | null;
  ownerId?: string | null;
  searchTerm?: string | null;
  statuses?: TicketEventStatus[] | null;
}

export interface InPersonActivityInput {
  address?: string | null;
  city?: string | null;
  country?: string | null;
  coveredExpenses?: CampaignActivityCoveredExpense[] | null;
  description?: string | null;
  duration?: string | null;
  files?: CampaignExampleFileInput[] | null;
  instructions?: string | null;
  possibleDates?: any[] | null;
  state?: string | null;
  venueName?: string | null;
  zip?: string | null;
}

export interface InitDeliverableFileMultipartUploadInput {
  campaignId: string;
  contentType: string;
  deliverableItemId: string;
  fileExt: string;
  partCnt: number;
}

export interface InitEditedVideoMultipartUploadInput {
  contentType: string;
  fileExt: string;
  partCnt: number;
  videoEditRequestId: string;
}

export interface InitStreamMultipartUploadInput {
  contentType: string;
  fileExt: string;
  partCnt: number;
}

export interface InitTransitionMultipartUploadInput {
  contentType: string;
  fileExt: string;
  name: string;
  partCnt: number;
}

export interface InterviewDateInput {
  scheduleDate: any;
  timeZone: TimeZoneInput;
}

export interface InterviewDateV2Input {
  tz?: string | null;
  utc: any;
}

export interface InterviewGeneralSettingsSettingInput {
  config: GeneralSettingsConfigInput;
  isEnabled?: boolean | null;
}

export interface InterviewHighValueMemorabiliaTriggerConfigInput {
  minPrice: number;
}

export interface InterviewHighValueMemorabiliaTriggerSettingInput {
  config: InterviewHighValueMemorabiliaTriggerConfigInput;
  interviewerIds?: string[] | null;
  isEnabled: boolean;
}

export interface InterviewHighValueMerchTriggerConfigInput {
  minPrice: number;
}

export interface InterviewHighValueMerchTriggerSettingInput {
  config: InterviewHighValueMerchTriggerConfigInput;
  interviewerIds?: string[] | null;
  isEnabled: boolean;
}

export interface InterviewNowDispatchSettingsConfigInput {
  batchDelayMinutes: number;
  batchSize: number;
}

export interface InterviewNowDispatchSettingsSettingInput {
  config: InterviewNowDispatchSettingsConfigInput;
}

export interface InterviewNowGeneralSettingsSettingInput {
  intervieweeIds?: string[] | null;
  isEnabled?: boolean | null;
}

export interface InterviewPPVParticipantTriggerSettingInput {
  interviewerIds?: string[] | null;
  isEnabled: boolean;
}

export interface InterviewSourceInput {
  interviewNowSessionId?: string | null;
  merchId?: number | null;
  productId?: string | null;
  streamId?: string | null;
  type: InterviewSourceType;
}

export interface InterviewUserRequestSettingInput {
  interviewerIds?: string[] | null;
  isEnabled?: boolean | null;
}

export interface InviteProcessingFeeSettingDetailsInput {
  agencyId?: string | null;
  inviteProcessingFee: number;
}

export interface IssueCompTicketsInput {
  category: TicketCompCategory;
  idempotencyKey: string;
  note?: string | null;
  quantity: number;
  recipientUserId?: string | null;
  ticketEventId: string;
  tierId: string;
}

export interface ListChannelMonetizationApplicationsInput {
  direction?: SortDirection | null;
  limit?: number | null;
  monthLabel?: string | null;
  offset?: number | null;
  status?: ChannelMonetizationApplicationStatus | null;
}

export interface LocationInput {
  city?: string | null;
  country: string;
  latitude?: number | null;
  longitude?: number | null;
  placeId?: string | null;
  placeText?: string | null;
  radius?: number | null;
  state?: string | null;
}

export interface LockSettingDetailsInput {
  durationSeconds: number;
}

export interface LoginAsInput {
  userId: string;
}

export interface ManagerRejectAndReassignMerchDesignInput {
  designRequestId: string;
  feedback: string;
  newDesignerId: string;
}

export interface ManagerRejectMerchDesignInput {
  designRequestId: string;
  feedback: string;
}

export interface MarkAffiliateCommissionsPaidInput {
  expectedUnpaidTotal: number;
  paidAtDateRange?: FromToDatesFilter | null;
  storeId?: string | null;
  userId: string;
}

export interface MemorabiliaFilterInput {
  auctionStatuses?: AuctionStatus[] | null;
  createdByRoles?: UserRole[] | null;
  description?: string | null;
  direction?: SortDirection | null;
  fulfillment?: MemorabiliaFulfillment | null;
  id?: string | null;
  ids?: string[] | null;
  isCreatedByAdmin?: boolean | null;
  isMarkedInappropriate?: boolean | null;
  isOrphanPage?: boolean | null;
  limit?: number | null;
  numberOfUnits?: number | null;
  offset?: number | null;
  orderBy?: MemorabiliaOrderBy | null;
  price?: FromToFilter | null;
  productTypes?: MemorabiliaProductType[] | null;
  requestPrice?: FromToFilter | null;
  saleMethods?: MemorabiliaSaleMethod[] | null;
  searchTerm?: string | null;
  sports?: number[] | null;
  statuses?: MemorabiliaStatus[] | null;
  storeIds?: string[] | null;
  storeName?: string | null;
  storeSlug?: string | null;
  storeStatuses?: StoreStatus[] | null;
  title?: string | null;
  withDeleted?: boolean | null;
}

export interface MemorabiliaImageInput {
  isMainImage?: boolean | null;
  memorabiliaImageFileKey: string;
}

export interface MerchCustomImageV2Input {
  isMain: boolean;
  key: string;
}

export interface MerchEstimatePrintFileSetInput {
  printFiles: VariantEstimatePrintFileInput[];
  variantSetIndices: number[];
}

export interface MerchProductColor {
  color?: string | null;
  colorCode?: string | null;
  colorCode2?: string | null;
}

export interface MerchProductCustomImageSetInput {
  customImages?: MerchCustomImageV2Input[] | null;
  variantSetIndices: number[];
}

export interface MerchProductPrintFileSetInput {
  printFiles: VariantPrintFileInput[];
  variantSetIndices: number[];
}

export interface MerchProductVariantSet {
  age: Age;
  gender: Gender;
  stitches?: string | null;
  threads?: string[] | null;
  variantIds: number[];
}

export interface MergeMerchInput {
  childMerchId: number[];
  parentMerchId: number;
  requestedProfit: number;
  title: string;
}

export interface ModeratorCreateInput {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string | null;
  socialMediaLink?: string | null;
}

export interface ModeratorEditInput {
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  moderatorId: string;
  password?: string | null;
  phoneNumber?: string | null;
  socialMediaLink?: string | null;
}

export interface ModeratorsFilterInput {
  direction?: SortDirection | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  limit?: number | null;
  moderatorIds?: string[] | null;
  offset?: number | null;
  orderBy?: ModeratorsOrderBy | null;
  phoneNumber?: number | null;
  status?: StoreStatus[] | null;
}

export interface MyCbTalentAudienceFiltersInput {
  ageRanges?: AudienceAgeRange[] | null;
  ethnicities?: AudienceEthnicity[] | null;
  gender?: AudienceGender | null;
  interests?: AudienceInterest[] | null;
  languages?: string[] | null;
  locations?: CampaignLocationInput[] | null;
}

export interface MyCbTalentFiltersInput {
  audience?: MyCbTalentAudienceFiltersInput | null;
  dateAdded?: FromToDatesFilter | null;
  engagementRateRange?: FromToFilter | null;
  excludedLocations?: CampaignLocationInput[] | null;
  genders?: StoreGender[] | null;
  hashtagInputs?: HashtagInput[] | null;
  hometownLocations?: HometownLocationInput[] | null;
  influencerCategoryIds?: number[] | null;
  locations?: CampaignLocationInput[] | null;
  maxAge?: number | null;
  minAge?: number | null;
  recentlyWorkedWith?: FromToDatesFilter | null;
  roles?: UserRole[] | null;
  search?: string | null;
  smPlatforms?: CampaignSmPlatform[] | null;
  socialFollowersRange?: FromToFilter | null;
  source?: CbMyTalentSource[] | null;
  sports?: string[] | null;
  status?: CbMyTalentStatus | null;
  workedWith?: boolean | null;
}

export interface MyCbTalentListInput {
  direction?: SortDirection | null;
  filters?: MyCbTalentFiltersInput | null;
  limit?: number | null;
  offset?: number | null;
  ownerId?: string | null;
  sortBy?: MyCbTalentSortKey | null;
}

export interface MySalesInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: StreamOrderSalesOrderBy | null;
  storeId?: string | null;
}

export interface MyTicketVenuesInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  ownerId?: string | null;
}

export interface PaginatedStreamOrdersInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderStatuses?: StreamOrderStatus[] | null;
  streamId: string;
}

export interface PastAppearanceStreamInput {
  description: string;
  hashtagInputs?: HashtagInput[] | null;
  imageFileKey?: string | null;
  mentionsInputs?: CreateMentionInput[] | null;
  name?: string | null;
  records: AppearanceStreamRecordInput[];
  scheduleDate?: any | null;
  scheduleDateV2?: DateV2Input | null;
  timeZone?: TimeZoneInput | null;
}

export interface PayoutOrdersFilterInput {
  id?: string | null;
  limit?: number | null;
  offset?: number | null;
  periodFrom: any;
  periodTo: any;
  storeId?: string | null;
}

export interface PitchSettingDetailsInput {
  campaignType: CampaignType;
  isRequired: boolean;
  pitch: string;
}

export interface PreviewCustomNotificationInput {
  followingUserIds?: string[] | null;
  locations?: LocationInput[] | null;
  sportNames: string[];
  targetUserIds?: string[] | null;
}

export interface PrintImageFilterInput {
  storeId: string;
}

export interface PrintImageInput {
  printImageId: string;
  userId?: string | null;
}

export interface PrintImageUploadInput {
  designRequestId?: string | null;
  image: any;
  userId?: string | null;
}

export interface ProcessingFeeSettingDetailsInput {
  campaignType?: CampaignType | null;
  launchFee: number;
}

export interface ProductPriceEstimateInput {
  changedStock?: number | null;
  fulfillment?: MemorabiliaFulfillment | null;
  numberOfUnits?: number | null;
  ownerId?: string | null;
  productId?: string | null;
  requestedPrice: number;
}

export interface ProductPrintFilePlacementInput {
  angle: number;
  left: number;
  printImageId: string;
  rotatedLeft: number;
  rotatedTop: number;
  scaleX: number;
  scaleY: number;
  top: number;
}

export interface PromoCodesFilterInput {
  amount?: FromToFilter | null;
  chargeSubject?: PromoCodesChargeSubject[] | null;
  direction?: SortDirection | null;
  endDate?: FromToDatesFilter | null;
  limit?: number | null;
  name?: string | null;
  offset?: number | null;
  orderBy?: PromoCodesOrderBy | null;
  startDate?: FromToDatesFilter | null;
}

export interface PsychosocialKeywordFilterInput {
  direction?: SortDirection | null;
  keyword?: string | null;
  limit?: number | null;
  names?: string[] | null;
  offset?: number | null;
  orderBy?: PsychosocialKeywordOrderBy | null;
}

export interface ReassignVideoEditRequestInput {
  feedback?: string | null;
  newVideoEditorId: string;
  videoEditRequestId: string;
  videoEditorId?: string | null;
}

export interface RecoverExperienceInput {
  id: string;
}

export interface RecoverMediaPostInput {
  id: string;
}

export interface RecoverMemorabiliaInput {
  id: string;
  storeId?: string | null;
}

export interface RecoverMerchProductInput {
  id: number;
}

export interface RecoverStreamInput {
  id: string;
}

export interface RefreshTokensInput {
  refreshToken: string;
}

export interface RefundTicketEventOrdersInput {
  ticketEventId: string;
}

export interface RefundTicketOrderInput {
  orderId: string;
}

export interface RegenerateStreamAffiliateLinkInput {
  linkId: string;
}

export interface ReinstateRejectedStoreInput {
  storeId: string;
}

export interface ReinstateSocialBoostOfferInput {
  offerId: string;
  status: CampaignOfferStatus;
}

export interface RejectAiClipCandidateInput {
  candidateId: string;
  ownerId?: string | null;
}

export interface RejectAwaitingStoreInput {
  storeId: string;
}

export interface RejectCbTaskExtensionInput {
  agencyFeedback?: string | null;
  extensionRequestId: string;
  offerId: string;
}

export interface RejectDeliverableInput {
  agencyFeedback: string;
  deliverableId: string;
  offerId: string;
  ownerId?: string | null;
}

export interface ReleaseCampaignLockInput {
  id: string;
  ownerId?: string | null;
}

export interface RemoveBannedEmailDomainInput {
  domain: string;
}

export interface RemoveCampaignCollabInput {
  campaignId: string;
  userId: string;
}

export interface RemoveInterviewerCapabilityInput {
  storeId: string;
}

export interface RemoveOfferFromCampaignInput {
  offerId: string;
}

export interface RemoveTicketEventParticipantInput {
  ticketEventId: string;
  userId: string;
}

export interface ReplaceCampaignSubmissionLinkInput {
  link: string;
  platformMediaId?: string | null;
  submissionId: string;
}

export interface RequestCbTaskExtensionInput {
  deliverableId: string;
  eventDate?: any | null;
  reason: string;
  requestedExtensionDays?: number | null;
  type: TaskExtensionRequestType;
}

export interface RescheduleTicketEventInput {
  admissionClosesAt: any;
  doorsOpenAt: any;
  endsAt: any;
  expectedVersion: number;
  salesCloseAt: any;
  salesOpenAt?: any | null;
  startsAt: any;
  ticketEventId: string;
}

/**
 * Reset interview from Completed/Scheduled to ScheduleAttempted
 */
export interface ResetInterviewAdminInput {
  id: string;
}

export interface ResetStreamInput {
  id: string;
}

export interface ResolveSocialBoostDisputeInput {
  offerId: string;
  resolution: SocialBoostDisputeResolution;
}

export interface ReuploadEditedVideoInput {
  acceptedStoreIds?: string[] | null;
  body: string;
  durationMs?: number | null;
  editedVideoId: string;
  hashtagInputs?: HashtagInput[] | null;
  id: string;
  mentionsInputs?: CreateMentionInput[] | null;
  thumbnailKey: string;
  title: string;
  video: CreateEditedVideoInput;
}

export interface ReviewChannelMonetizationApplicationInput {
  applicationId: string;
  decision: ChannelMonetizationApplicationStatus;
  rejectionReason?: string | null;
}

export interface ReviewDeliverablesInput {
  deliverableItems: DeliverableReviewItemInput[];
  offerId: string;
}

export interface RevokeCompTicketOrderInput {
  orderId: string;
}

export interface SalesReportInput {
  endDate?: any | null;
  startDate: any;
}

export interface ScheduleAvailabilityIntervalInput {
  from: string;
  to: string;
}

export interface ScheduleDateAvailabilityInput {
  date: string;
  intervals: ScheduleAvailabilityIntervalInput[];
}

export interface ScheduleDateInput {
  at: any;
  offset?: number | null;
  tzCode?: string | null;
}

export interface ScheduleInterviewAdminInput {
  hashtagInputs?: HashtagInput[] | null;
  id: string;
  imageFileKey?: string | null;
  mentionsInputs?: CreateMentionInput[] | null;
  name?: string | null;
  scheduleDate?: InterviewDateInput | null;
  scheduleDateV2?: InterviewDateV2Input | null;
}

export interface ScheduleInterviewInput {
  hashtagInputs?: HashtagInput[] | null;
  id: string;
  imageFileKey?: string | null;
  mentionsInputs?: CreateMentionInput[] | null;
  name?: string | null;
  scheduleDate?: InterviewDateInput | null;
  scheduleDateV2?: InterviewDateV2Input | null;
}

export interface ScheduleWeekDayAvailabilityInput {
  intervals: ScheduleAvailabilityIntervalInput[];
  weekday: WeekDay;
}

export interface ScheduledPostDateV2Input {
  tz?: string | null;
  utc: any;
}

export interface SearchBookMeCampaignInput {
  criteria: SearchBookMeCriteriaInput;
  limit?: number | null;
  offset?: number | null;
  ownerId?: string | null;
}

export interface SearchBookMeCriteriaInput {
  athleticLevels?: StoreAthleticLevel[] | null;
  audienceFilters?: AudienceFiltersInput | null;
  budgetRange?: FromToFilter | null;
  direction?: SortDirection | null;
  engagementRateRange?: FromToFilter | null;
  excludedLocations?: CampaignLocationInput[] | null;
  genders?: StoreGender[] | null;
  hashtagInputs?: HashtagInput[] | null;
  hometownLocations?: HometownLocationInput[] | null;
  locations?: CampaignLocationInput[] | null;
  maxAge?: number | null;
  minAge?: number | null;
  orderBy?: SearchCampaignStoresOrderBy | null;
  roles?: UserRole[] | null;
  socialFollowersRange?: FromToFilter | null;
  sports?: string[] | null;
}

export interface SearchCampaignCriteriaInput {
  audienceFilters?: AudienceFiltersInput | null;
  budget?: number | null;
  direction?: SortDirection | null;
  engagementRateRange?: FromToFilter | null;
  excludedLocations?: CampaignLocationInput[] | null;
  flatFeePerStore?: number | null;
  genders?: StoreGender[] | null;
  hashtagInputs?: HashtagInput[] | null;
  hometownLocations?: HometownLocationInput[] | null;
  locations?: CampaignLocationInput[] | null;
  maxAge?: number | null;
  minAge?: number | null;
  orderBy?: SearchCampaignStoresOrderBy | null;
  roles?: UserRole[] | null;
  smPlatforms?: CampaignSmPlatform[] | null;
  socialFollowersRange?: FromToFilter | null;
  sports?: string[] | null;
}

export interface SearchCampaignStoresInput {
  criteria: SearchCampaignCriteriaInput;
  limit?: number | null;
  offset?: number | null;
  ownerId?: string | null;
}

export interface SearchCustomCriteriaInput {
  ageRanges?: TalentAgeRangeInput[] | null;
  audienceFilters?: AudienceFiltersInput | null;
  direction?: SortDirection | null;
  excludePreviouslyDeclined?: boolean | null;
  excludePreviouslyWorkedWith?: boolean | null;
  excludedLocations?: CampaignLocationInput[] | null;
  flatFeePerStore?: number | null;
  genders?: StoreGender[] | null;
  hashtagInputs?: HashtagInput[] | null;
  hometownLocations?: HometownLocationInput[] | null;
  influencerCategoryIds?: number[] | null;
  locations?: CampaignLocationInput[] | null;
  maxAge?: number | null;
  minAge?: number | null;
  orderBy?: SearchCampaignStoresOrderBy | null;
  platformCriteria?: CustomPlatformCriteriaInput[] | null;
  roles?: UserRole[] | null;
  sports?: string[] | null;
}

export interface SearchCustomStoresInput {
  campaignId?: string | null;
  criteria: SearchCustomCriteriaInput;
  limit?: number | null;
  offset?: number | null;
  ownerId?: string | null;
}

export interface SearchSocialBoostCampaignInput {
  criteria: SearchSocialBoostCriteriaInput;
  limit?: number | null;
  offset?: number | null;
}

export interface SearchSocialBoostCriteriaInput {
  audienceFilters?: AudienceFiltersInput | null;
  budget?: number | null;
  direction?: SortDirection | null;
  excludedLocations?: CampaignLocationInput[] | null;
  genders?: StoreGender[] | null;
  hashtagInputs?: HashtagInput[] | null;
  hometownLocations?: HometownLocationInput[] | null;
  influencerCategoryIds?: number[] | null;
  locations?: CampaignLocationInput[] | null;
  maxAge?: number | null;
  minAge?: number | null;
  orderBy?: SearchCampaignStoresOrderBy | null;
  platformCriteria?: CustomPlatformCriteriaInput[] | null;
  roles?: UserRole[] | null;
  sports?: string[] | null;
}

export interface SearchSocialShareCampaignInput {
  criteria: SearchSocialShareCriteriaInput;
  limit?: number | null;
  offset?: number | null;
  ownerId?: string | null;
}

export interface SearchSocialShareCriteriaInput {
  audienceFilters?: AudienceFiltersInput | null;
  budget?: number | null;
  direction?: SortDirection | null;
  engagementRateRange?: FromToFilter | null;
  excludedLocations?: CampaignLocationInput[] | null;
  flatFeePerStore?: number | null;
  genders?: StoreGender[] | null;
  hashtagInputs?: HashtagInput[] | null;
  hometownLocations?: HometownLocationInput[] | null;
  locations?: CampaignLocationInput[] | null;
  maxAge?: number | null;
  minAge?: number | null;
  orderBy?: SearchCampaignStoresOrderBy | null;
  roles?: UserRole[] | null;
  smPlatforms?: CampaignSmPlatform[] | null;
  socialFollowersRange?: FromToFilter | null;
  sports?: string[] | null;
}

export interface SearchSponsoredAppearanceCriteriaInput {
  appearanceTargetType?: CampaignActivityTargetType | null;
  appearanceVideoType?: SponsoredAppearanceVideoType | null;
  audienceFilters?: AudienceFiltersInput | null;
  budget?: number | null;
  direction?: SortDirection | null;
  engagementRateRange?: FromToFilter | null;
  excludedLocations?: CampaignLocationInput[] | null;
  flatFeePerStore?: number | null;
  genders?: StoreGender[] | null;
  hashtagInputs?: HashtagInput[] | null;
  hometownLocations?: HometownLocationInput[] | null;
  locations?: CampaignLocationInput[] | null;
  maxAge?: number | null;
  minAge?: number | null;
  orderBy?: SearchCampaignStoresOrderBy | null;
  roles?: UserRole[] | null;
  socialFollowersRange?: FromToFilter | null;
  sports?: string[] | null;
  withAmplify?: boolean | null;
}

export interface SearchSponsoredAppearanceInput {
  criteria: SearchSponsoredAppearanceCriteriaInput;
  limit?: number | null;
  offset?: number | null;
  ownerId?: string | null;
}

export interface SearchUgcCriteriaInput {
  audienceFilters?: AudienceFiltersInput | null;
  budget?: number | null;
  direction?: SortDirection | null;
  engagementRateRange?: FromToFilter | null;
  excludedLocations?: CampaignLocationInput[] | null;
  flatFeePerStore?: number | null;
  genders?: StoreGender[] | null;
  hashtagInputs?: HashtagInput[] | null;
  hometownLocations?: HometownLocationInput[] | null;
  locations?: CampaignLocationInput[] | null;
  maxAge?: number | null;
  minAge?: number | null;
  orderBy?: SearchCampaignStoresOrderBy | null;
  roles?: UserRole[] | null;
  socialFollowersRange?: FromToFilter | null;
  sports?: string[] | null;
}

export interface SearchUgcStoresInput {
  criteria: SearchUgcCriteriaInput;
  limit?: number | null;
  offset?: number | null;
  ownerId?: string | null;
}

export interface SendCampaignCollabInviteInput {
  campaignId: string;
  email: string;
  roleId: string;
}

export interface SendManualInterviewInvitesInput {
  adminNotes?: string | null;
  intervieweeIds: string[];
  interviewerId?: string | null;
  source: InterviewSourceInput;
  streamImageKey?: string | null;
  streamTitle?: string | null;
}

export interface SendMerchDesignToReviewInput {
  designRequestId: string;
  socialMediaPackImages?: SocialMediaPackImageInput[] | null;
}

export interface SetAiClipperSettingsInput {
  AutoApproval?: AiClipperAutoApprovalSettingInput | null;
  PostAutoGeneration?: AiClipperPostAutoGenerationSettingInput | null;
}

export interface SetAiClipperUserAccessInput {
  channelLogoKey?: string | null;
  isEnabled: boolean;
  note?: string | null;
  userId: string;
  validUntil?: any | null;
}

export interface SetBrandDealSettingsInput {
  contactEmail?: string | null;
  contactPhone?: string | null;
  disabledCategories?: string[] | null;
  isAcceptAll?: boolean | null;
  isAcceptingCpmCampaigns?: boolean | null;
  isAcceptingFreeProducts?: boolean | null;
  isArticlesPrEnabled?: boolean | null;
  minBookMePrice?: number | null;
  minFlatPrice?: number | null;
  minSocialPrice?: number | null;
  minSocialSharePrice?: number | null;
  minSponsoredLivePrice?: number | null;
  ownerId?: string | null;
}

export interface SetCampaignAgreementSignatoryInput {
  agreementSignatoryId: string;
  campaignId: string;
}

export interface SetCbEntitlementInput {
  credits?: number | null;
  ownerId: string;
  performedById: string;
  seats?: number | null;
  type: CbEntitlementType;
  validFrom?: any | null;
  validUntil?: any | null;
}

export interface SetCbSettingInput {
  agencySignUpEmailVerification?: AgencySignUpEmailVerificationSettingDetailsInput | null;
  cpmPayout?: CpmPayoutSettingDetailsInput | null;
  deliverableRevisionLimit?: DeliverableRevisionLimitSettingDetailsInput | null;
  digitalAgreement?: DigitalAgreementSettingDetailsInput | null;
  fee?: FeeSettingDetailsInput | null;
  inviteProcessingFee?: InviteProcessingFeeSettingDetailsInput | null;
  lock?: LockSettingDetailsInput | null;
  pitch?: PitchSettingDetailsInput | null;
  processingFee?: ProcessingFeeSettingDetailsInput | null;
  type: CbSettingType;
}

export interface SetChannelMonetizationMilestoneTargetsInput {
  programId: string;
  targets: ChannelMonetizationMilestoneTargetInput[];
}

export interface SetEngagementNotificationSettingInput {
  busyWindowMinutes?: number | null;
  countPeopleHours?: number | null;
  firstWindowMinutes?: number | null;
  pushesPerDay?: number | null;
  pushesPerHour?: number | null;
  quietResetHours?: number | null;
  secondWindowMinutes?: number | null;
  thirdWindowMinutes?: number | null;
}

export interface SetGlobalFeatureLimitInput {
  featureKey: FeatureLimitKey;
  monthlyLimit?: number | null;
}

export interface SetInterviewSettingsInput {
  GeneralSettings?: InterviewGeneralSettingsSettingInput | null;
  HighValueMemorabiliaTrigger?: InterviewHighValueMemorabiliaTriggerSettingInput | null;
  HighValueMerchTrigger?: InterviewHighValueMerchTriggerSettingInput | null;
  InterviewNowDispatchSettings?: InterviewNowDispatchSettingsSettingInput | null;
  InterviewNowGeneralSettings?: InterviewNowGeneralSettingsSettingInput | null;
  PPVParticipantTrigger?: InterviewPPVParticipantTriggerSettingInput | null;
  UserRequest?: InterviewUserRequestSettingInput | null;
}

export interface SetInterviewerCapabilityInput {
  isIncludedInAutoAssignment: boolean;
  scheduleLink?: string | null;
  sportIds?: number[] | null;
  storeId: string;
}

export interface SetMyScheduleInput {
  dates?: ScheduleDateAvailabilityInput[] | null;
  durationMinutes?: number | null;
  minimumNoticeMinutes?: number | null;
  slotStepMinutes?: number | null;
  timezone?: string | null;
  type?: ScheduleType | null;
  weekdays?: ScheduleWeekDayAvailabilityInput[] | null;
}

export interface SetMySubscriptionItemInput {
  priceId: string;
  quantity: number;
}

export interface SetPpvAutoFreeInput {
  hours?: number | null;
  isEnabled?: boolean | null;
}

export interface SetScheduleInput {
  dates?: ScheduleDateAvailabilityInput[] | null;
  durationMinutes?: number | null;
  minimumNoticeMinutes?: number | null;
  slotStepMinutes?: number | null;
  timezone?: string | null;
  type?: ScheduleType | null;
  userId: string;
  weekdays?: ScheduleWeekDayAvailabilityInput[] | null;
}

export interface SetSocialMediaIntegrationSettingsInput {
  allowedUserIds?: string[] | null;
  isEnabled?: boolean | null;
}

export interface SetStorePriceMarginsInput {
  amaMargin?: number | null;
  merchMargin?: number | null;
  productMargin?: number | null;
  storeId: string;
  streamMargin?: number | null;
  tipMargin?: number | null;
}

export interface SetStreamAffiliateLinkCommissionInput {
  commissionPercent: number;
  linkId: string;
}

export interface SetStreamAffiliateLinkStatusInput {
  linkId: string;
  status: StreamAffiliateLinkStatus;
}

export interface SetTicketEventMatchupsInput {
  matchups: CreateMatchupInput[];
  ticketEventId: string;
}

export interface SetTicketPresaleCodeActiveInput {
  active: boolean;
  presaleCodeId: string;
}

export interface SetTicketSaleStatusInput {
  expectedVersion: number;
  status: TicketEventStatus;
  ticketEventId: string;
}

export interface SetTicketingSettingInput {
  defaultEventDurationSeconds?: number | null;
  defaultSalesCloseAfterStartSeconds?: number | null;
  gateEnabled?: boolean | null;
  holdSeconds?: number | null;
  isEnabled?: boolean | null;
  isLaunched?: boolean | null;
  maxSalesCloseAfterStartSeconds?: number | null;
  maxTicketPrice?: number | null;
  minTicketPrice?: number | null;
  paymentResolutionDeadlineSeconds?: number | null;
  salesEnabled?: boolean | null;
  serviceFeePerTicket?: number | null;
  serviceFeePercent?: number | null;
  transferWindowHours?: number | null;
  transfersEnabled?: boolean | null;
  workersEnabled?: boolean | null;
}

export interface SetUserFeatureLimitInput {
  featureKey: FeatureLimitKey;
  monthlyLimit?: number | null;
  userId: string;
}

export interface SetVideoEditRequestSettingsInput {
  InterviewTrigger?: VideoEditRequestBooleanTriggerSettingInput | null;
  MediaLabTrigger?: VideoEditRequestTriggerSettingInput | null;
  SponsoredAppearanceTrigger?: VideoEditRequestBooleanTriggerSettingInput | null;
  StreamTrigger?: VideoEditRequestTriggerSettingInput | null;
}

export interface SignInInput {
  email: string;
  password: string;
}

export interface SignOutInput {
  refreshToken: string;
}

export interface SignUpBasicDetailsInput {
  avatarKey?: string | null;
  email: string;
  emailOtpVerificationId?: string | null;
  firstName: string;
  lastName: string;
  password?: string | null;
  phoneNumberE164?: string | null;
  phoneOptIn?: boolean | null;
  phoneOtpVerificationId?: string | null;
  socialSessionToken?: string | null;
  username?: string | null;
}

export interface SignUpV2Input {
  basic: SignUpBasicDetailsInput;
  source?: SignupSourceInput | null;
}

export interface SignupSourceExtraInput {
  campaignId?: string | null;
  contactId?: string | null;
  type: SignUpSource;
}

export interface SignupSourceInput {
  domain?: string | null;
  extra?: SignupSourceExtraInput | null;
  signUpSource: SignUpSource;
  signUpSourceId?: string | null;
  signUpSourceRequestId?: string | null;
}

export interface SocialAccountInput {
  link: string;
  platform: SocialMediaType;
}

export interface SocialActivityInput {
  avoid?: string | null;
  brandName?: string | null;
  encouraged?: string | null;
  files?: CampaignExampleFileInput[] | null;
  hashtags?: string[] | null;
  instructions?: string | null;
  linkBio?: boolean | null;
  linkBioDurationDays?: number | null;
  mediaType?: CampaignMediaType[] | null;
  physicalProduct?: boolean | null;
  physicalProductType?: string | null;
  pinnedPost?: boolean | null;
  pinnedPostDurationDays?: number | null;
  postDueFrom?: any | null;
  postDueTo?: any | null;
  productName?: string | null;
  productValue?: number | null;
  profileMentions?: string | null;
  promoCodes?: string[] | null;
  promoUrls?: string[] | null;
  quantityInstructions?: string | null;
  script?: string | null;
  submissionDue?: any | null;
  suggestedCaption?: string | null;
  tasks?: CreateCampaignTaskInput[] | null;
  tasksV2?: CreateCampaignTaskV2Input[] | null;
  website?: string | null;
}

export interface SocialBoostActivityDetailsInput {
  brandName?: string | null;
  caption?: string | null;
  linkStickerTitle?: string | null;
  linkStickerUrl?: string | null;
  postUrl?: string | null;
  tags?: string[] | null;
  website?: string | null;
}

export interface SocialBoostActivityInput {
  socialBoost?: SocialBoostActivityDetailsInput | null;
  type?: CampaignActivityType | null;
}

export interface SocialMediaPackImageInput {
  imageFileKey: string;
  imgURL?: string | null;
  label?: string | null;
}

export interface SocialShareActivityDetailsInput {
  brandName?: string | null;
  description?: string | null;
  files?: CampaignExampleFileInput[] | null;
  instructions?: string | null;
  shareUrl?: string | null;
  website?: string | null;
}

export interface SocialShareActivityInput {
  socialShare?: SocialShareActivityDetailsInput | null;
  type?: CampaignActivityType | null;
}

export interface SponsoredAppearanceActivityDetailsInput {
  guest?: SponsoredAppearanceGuestTargetInput | null;
  product?: SponsoredAppearanceProductTargetInput | null;
  target?: CampaignActivityTargetType | null;
  videoType?: SponsoredAppearanceVideoType | null;
  withAmplify?: boolean | null;
}

export interface SponsoredAppearanceActivityInput {
  sponsoredAppearance?: SponsoredAppearanceActivityDetailsInput | null;
  type?: CampaignActivityType | null;
}

export interface SponsoredAppearanceGuestTargetInput {
  bio?: string | null;
  company?: string | null;
  email?: string | null;
  instagram?: string | null;
  instructions?: string | null;
  linkedin?: string | null;
  name?: string | null;
  otherSocial?: string | null;
}

export interface SponsoredAppearanceProductTargetInput {
  bio?: string | null;
  files?: CampaignExampleFileInput[] | null;
  instagram?: string | null;
  instructions?: string | null;
  linkedin?: string | null;
  name?: string | null;
  otherSocial?: string | null;
  physicalProduct?: boolean | null;
  physicalProductType?: string | null;
  productName?: string | null;
  productValue?: number | null;
  website?: string | null;
}

export interface StoreDetailsInput {
  athleticLevel?: StoreAthleticLevel | null;
  avatar?: any | null;
  avatarFileKey?: string | null;
  bio?: string | null;
  birthDate?: string | null;
  bitcoinReceivingAddress?: string | null;
  careerStatus?: StoreCareerStatus | null;
  city?: string | null;
  collegeId?: string | null;
  country?: string | null;
  cover?: any | null;
  coverVideoKey?: string | null;
  description?: string | null;
  facebookFollowing?: number | null;
  facebookLink?: string | null;
  favoriteNumber?: number | null;
  gender?: StoreGender | null;
  gymRole?: string | null;
  hometown?: string | null;
  hometownCountry?: string | null;
  hometownLocation?: EarthCoordinateInput | null;
  hometownState?: string | null;
  instagramFollowing?: number | null;
  instagramLink?: string | null;
  isBirthDayKnown?: boolean | null;
  isBirthMonthKnown?: boolean | null;
  leagueId?: string | null;
  location?: EarthCoordinateInput | null;
  organizationType?: OrganizationType | null;
  otherCollege?: string | null;
  otherLeague?: string | null;
  otherTeam?: string | null;
  signUpFlow?: SignUpFlow | null;
  socialMediaLink?: string | null;
  state?: string | null;
  storeName?: string | null;
  storeTitle?: string | null;
  subtype?: AccountSubType | null;
  teamId?: string | null;
  tiktokFollowing?: number | null;
  tiktokLink?: string | null;
  twitterFollowing?: number | null;
  twitterLink?: string | null;
  website?: string | null;
  youtubeFollowing?: number | null;
  youtubeLink?: string | null;
}

export interface StoreEditAdminInput {
  storeDetails?: StoreDetailsInput | null;
  storeId?: string | null;
  storeManagementDetails?: StoreManagementDetailsInput | null;
  userDetails?: UserDetailsInput | null;
}

export interface StoreGetInput {
  id?: string | null;
  slug?: string | null;
}

export interface StoreInterviewerFilterInput {
  direction?: SortDirection | null;
  email?: string | null;
  firstName?: string | null;
  interviewerIds?: string[] | null;
  lastName?: string | null;
  limit?: number | null;
  name?: string | null;
  offset?: number | null;
  orderBy?: StoreInterviewerOrderBy | null;
  phoneNumber?: number | null;
  status?: StoreStatus[] | null;
}

export interface StoreManagementDetailsInput {
  adConnected: boolean;
  affinities?: string | null;
  agencyName?: string | null;
  agencyWebsite?: string | null;
  agentEmail?: string | null;
  agentName?: string | null;
  appearance?: string | null;
  conflictsOfInterestsOrNonInterests?: string | null;
  currentSponsors?: string | null;
  designRequestsPerMonthLimit?: number | null;
  facebookFollowing?: number | null;
  gender?: StoreGender | null;
  inbound?: string | null;
  initialAssessment?: number | null;
  instagramFollowing?: number | null;
  isBirthDayKnown?: boolean | null;
  isBirthMonthKnown?: boolean | null;
  latestAssessment?: number | null;
  managedById?: string | null;
  pressConferenceOrAmplifiedInterview?: string | null;
  signing?: string | null;
  socialConnected: boolean;
  socialPost?: string | null;
  tiktokFollowing?: number | null;
  twitterFollowing?: number | null;
  watchParty?: string | null;
  youtubeFollowing?: number | null;
}

export interface StorePromoCodePayloadInput {
  storeIds: string[];
}

export interface StoreStatusInput {
  storeId: string;
}

export interface StoresFilterInput {
  areaOfInfluenceIds?: string[] | null;
  direction?: SortDirection | null;
  hasActiveAma?: boolean | null;
  hasActiveExperiences?: boolean | null;
  hasActiveMerch?: boolean | null;
  hasActiveProducts?: boolean | null;
  hasActiveStreams?: boolean | null;
  hasAreaOfInfluence?: boolean | null;
  hasBirthDate?: boolean | null;
  hasContent?: boolean | null;
  hasPsychosocialKeywords?: boolean | null;
  hashtagIds?: number[] | null;
  id?: string | null;
  isShoppingEnabled?: boolean | null;
  isStreamer?: boolean | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: StoresOrderBy | null;
  psychosocialKeywordsIds?: string[] | null;
  searchTerm?: string | null;
  slug?: string | null;
  sportId?: number | null;
  sports?: number[] | null;
  status?: StoreStatus[] | null;
  storeIds?: string[] | null;
  storeName?: string | null;
}

export interface StreamAffiliateLinksInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: StreamAffiliateLinksOrderBy | null;
  status?: StreamAffiliateLinkStatus | null;
  streamId?: string | null;
  ticketEventId?: string | null;
}

export interface StreamAffiliateStreamInput {
  streamId?: string | null;
  ticketEventId?: string | null;
}

export interface StreamCreateInput {
  affiliateCommissionPercent?: number | null;
  affiliateEnabled?: boolean | null;
  chatEnabled?: boolean | null;
  description: string;
  fanPollingEnabled?: boolean | null;
  hashtagInputs?: HashtagInput[] | null;
  image?: any | null;
  imageFileKey?: string | null;
  isFree?: boolean | null;
  isHidden?: boolean | null;
  isPPV?: boolean | null;
  matchups?: CreateMatchupInput[] | null;
  mentionsInputs?: CreateMentionInput[] | null;
  moderatorId?: string | null;
  name?: string | null;
  participantIds?: string[] | null;
  postEventContentHubEnabled?: boolean | null;
  price?: number | null;
  repeatingTitle?: string | null;
  repeatsEveryEnum?: StreamIntervalEnum | null;
  requestedPrice?: number | null;
  scheduleDate?: any | null;
  scheduleDateV2?: DateV2Input | null;
  sharePickGraphicsEnabled?: boolean | null;
  sponsors?: StreamCreateSponsorsInput[] | null;
  sportIds?: number[] | null;
  timeZone?: TimeZoneInput | null;
}

export interface StreamCreateSponsorsInput {
  id?: string | null;
  imageFile?: any | null;
  imageFileKey?: string | null;
  logo?: string | null;
  name: string;
  promoMessage?: string | null;
}

export interface StreamFilterInput {
  accountTypes?: AccountType[] | null;
  direction?: SortDirection | null;
  haveSponsor?: boolean | null;
  id?: string | null;
  ids?: string[] | null;
  isPPV?: boolean | null;
  isPersonalized?: boolean | null;
  limit?: number | null;
  moderatorId?: string | null;
  name?: string | null;
  offset?: number | null;
  orderBy?: StreamOrderBy | null;
  ppvStreamId?: string | null;
  price?: FromToFilter | null;
  priceCategories?: StreamPriceCategory[] | null;
  publicStreamCategory?: PublicStreamCategory[] | null;
  scheduleDate?: FromToDatesFilter | null;
  searchTerm?: string | null;
  slug?: string | null;
  sportIds?: number[] | null;
  storeId?: string | null;
  storeIds?: string[] | null;
  storeName?: string | null;
  storeSlug?: string | null;
  storeStatus?: StoreStatus | null;
  streamStatus?: StreamStatus[] | null;
  streamSubtypeFilter?: StreamSubtypeFilter[] | null;
  tzcodes?: string[] | null;
  withCopies?: boolean | null;
  withDeleted?: boolean | null;
}

export interface StreamImageItemInput {
  contentType: string;
  ext: string;
}

export interface StreamNoteCreateInput {
  note: string;
  relativeTs?: number | null;
  streamId: string;
  streamRecordId?: number | null;
}

export interface StreamOrderAndTipsTypeInput {
  customerEmail?: string | null;
  customerName?: string | null;
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: MyTipsAndOrdersSalesOrderBy | null;
  paidAtDateRange?: FromToDatesFilter | null;
  storeId?: string | null;
}

export interface StreamOrdersQueryInput {
  createdAtDateRange?: FromToDatesFilter | null;
  customerId: string;
  direction?: SortDirection | null;
  email?: string | null;
  limit?: number | null;
  name?: string | null;
  offset?: number | null;
  orderBy?: StreamOrderByFilter | null;
  orderStatus?: StreamOrderStatus[] | null;
  streamStatus?: StreamStatus[] | null;
}

export interface StreamParticipantInviteInputAdmin {
  storeId: string;
  streamId: string;
}

export interface StreamParticipantRowsInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  statuses?: StreamParticipantRowStatus[] | null;
  streamId?: string | null;
  ticketEventId?: string | null;
}

export interface StreamSalesInput {
  direction?: SortDirection | null;
  limit?: number | null;
  name?: string | null;
  offset?: number | null;
  orderBy?: StreamSalesOrderBy | null;
  scheduledDateRange?: FromToDatesFilter | null;
  storeId?: string | null;
  storeName?: string | null;
}

export interface StreamUpdateInput {
  affiliateCommissionPercent?: number | null;
  affiliateEnabled?: boolean | null;
  chatEnabled?: boolean | null;
  description: string;
  fanPollingEnabled?: boolean | null;
  hashtagInputs?: HashtagInput[] | null;
  id: string;
  image?: any | null;
  imageFileKey?: string | null;
  isHidden?: boolean | null;
  isPPV?: boolean | null;
  matchups?: CreateMatchupInput[] | null;
  mentionsInputs?: CreateMentionInput[] | null;
  moderatorId?: string | null;
  name?: string | null;
  participantIds?: string[] | null;
  postEventContentHubEnabled?: boolean | null;
  repeatingTitle?: string | null;
  repeatsEveryEnum?: StreamIntervalEnum | null;
  scheduleDate?: any | null;
  scheduleDateV2?: DateV2Input | null;
  sharePickGraphicsEnabled?: boolean | null;
  sponsors?: StreamCreateSponsorsInput[] | null;
  sportIds?: number[] | null;
  timeZone?: TimeZoneInput | null;
}

export interface SubmitCampaignDeliverableItemV2Input {
  copy?: string | null;
  deliverableItemId: string;
  files?: SubmitCampaignDeliverableUploadedFileInput[] | null;
  key?: string | null;
  link?: string | null;
  name?: string | null;
  type: CBDeliverableItemType;
  videoTranscodingJobId?: string | null;
}

export interface SubmitCampaignDeliverableUploadedFileInput {
  key: string;
  name: string;
  type: CampaignMediaType;
  videoTranscodingJobId?: string | null;
}

export interface SubmitCampaignDeliverablesForReviewInput {
  files?: DeliverableFileInput[] | null;
  items?: DeliverableItemInput[] | null;
  offerId: string;
  ownerId?: string | null;
  postCopy?: string | null;
}

export interface SubmitCampaignDeliverablesForReviewV2Input {
  items: SubmitCampaignDeliverableItemV2Input[];
  offerId: string;
  ownerId?: string | null;
}

export interface SubmitCampaignOfferResultsInput {
  offerId: string;
  ownerId?: string | null;
  submissions?: CampaignOfferSubmissionInput[] | null;
}

export interface SuggestUsernameInput {
  firstName: string;
  lastName: string;
  profileName?: string | null;
  subtype?: AccountSubType | null;
}

export interface SwitchToCreatorInput {
  avatarKey?: string | null;
  bio?: string | null;
  birthDate?: string | null;
  city?: string | null;
  country?: string | null;
  emailOtpVerificationId?: string | null;
  gender?: StoreGender | null;
  level?: StoreAthleticLevel | null;
  location?: EarthCoordinateInput | null;
  ownerId?: string | null;
  phoneNumberE164: string;
  phoneOptIn: boolean;
  phoneOtpVerificationId?: string | null;
  profileName: string;
  socialAccounts?: SocialAccountInput[] | null;
  sportIds: number[];
  state?: string | null;
  subtype: AccountSubType;
  username: string;
}

export interface TakeCampaignLockInput {
  expiresInSeconds?: number | null;
  id: string;
}

export interface TalentAgeRangeInput {
  maxAge?: number | null;
  minAge: number;
}

export interface TicketEventImageUploadInput {
  files: StreamImageItemInput[];
}

export interface TicketEventOrdersInput {
  direction?: SortDirection | null;
  kinds?: TicketOrderKind[] | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: TicketEventOrderSort | null;
  statuses?: TicketOrderStatus[] | null;
  ticketEventId: string;
}

export interface TicketEventSalesSummariesInput {
  ticketEventIds: string[];
}

export interface TicketOrderHistoryInput {
  orderId: string;
}

export interface TicketScanHistoryInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  results?: TicketRedemptionResult[] | null;
  search?: string | null;
  sortBy?: TicketScanSort | null;
  ticketEventId: string;
}

export interface TicketTierDetailsInput {
  capacity: number;
  description?: string | null;
  label: string;
  maxPerOrder?: number | null;
  price: number;
  salesCloseAt?: any | null;
  salesOpenAt?: any | null;
}

export interface TicketVenueDetailsInput {
  addressLine1: string;
  addressLine2?: string | null;
  city: string;
  country: string;
  latitude: number;
  longitude: number;
  name: string;
  postalCode: string;
  region: string;
  timezone: string;
}

export interface TicketVenuePlacePredictionsInput {
  query: string;
  sessionToken?: string | null;
}

export interface TicketingOverviewInput {
  from?: any | null;
  to?: any | null;
}

export interface TimeZoneInput {
  offset?: number | null;
  tzCode?: string | null;
}

export interface UgcActivityDetailsInput {
  avoid?: string | null;
  brandName?: string | null;
  encouraged?: string | null;
  files?: CampaignExampleFileInput[] | null;
  instructions?: string | null;
  physicalProduct?: boolean | null;
  physicalProductType?: string | null;
  productName?: string | null;
  productValue?: number | null;
  promoCodes?: string[] | null;
  promoUrls?: string[] | null;
  tasks?: CreateCampaignContentTaskInput[] | null;
  website?: string | null;
}

export interface UgcActivityInput {
  type?: CampaignActivityType | null;
  ugc?: UgcActivityDetailsInput | null;
}

export interface UnhideStreamInput {
  id: string;
}

export interface UnwaiveLaunchFeeInput {
  campaignId: string;
}

export interface UpdateAddressInput {
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  company?: string | null;
  country?: string | null;
  countryCode?: string | null;
  email?: string | null;
  firstName?: string | null;
  id: string;
  isDefault?: boolean | null;
  lastName?: string | null;
  phone?: string | null;
  phoneNumberE164?: string | null;
  state?: string | null;
  stateCode?: string | null;
  zipCode?: string | null;
}

export interface UpdateAiClipNotesInput {
  notes?: AiClipNoteInput[] | null;
  streamRecordId?: number | null;
  streamSlug: string;
  userSlug: string;
}

export interface UpdateArticleInput {
  articleUrl?: string | null;
  content?: string | null;
  hashtagInputs?: HashtagInput[] | null;
  id: string;
  imageLabel?: string | null;
  key?: string | null;
  mentionsInputs?: CreateMentionInput[] | null;
  status?: ArticleStatus | null;
  storeIds?: string[] | null;
  title?: string | null;
}

export interface UpdateBookMeCampaignInput {
  activities?: BookMeActivityInput[] | null;
  applicationDeadlineDays?: number | null;
  applicationDeadlineEnabled?: boolean | null;
  brandName?: string | null;
  criteria?: SearchBookMeCriteriaInput | null;
  dueDate?: any | null;
  flatFeePerStore?: number | null;
  id: string;
  internalName?: string | null;
  lockEnabled?: boolean | null;
  name?: string | null;
  ownerId?: string | null;
  talentId?: string | null;
  usageRights?: boolean | null;
  usageRightsText?: string | null;
}

export interface UpdateBrandProductCategoryInput {
  id: string;
  name: string;
}

export interface UpdateBrandRestrictedCategoryInput {
  id: string;
  name: string;
}

export interface UpdateCampaignCollabRoleInput {
  campaignId: string;
  newRoleId: string;
  userId: string;
}

export interface UpdateCampaignDeadlinesInput {
  applicationDeadlineEnabled: boolean;
  campaignId: string;
  dueDate?: any | null;
}

export interface UpdateCampaignInput {
  criteria?: SearchCampaignCriteriaInput | null;
  details?: CreateCampaignDetailsInput | null;
  finalContentEnabled?: boolean | null;
  id: string;
  lockEnabled?: boolean | null;
}

export interface UpdateCampaignOwnershipInput {
  campaignId: string;
  newOwnerId: string;
}

export interface UpdateCbApplicationAnswerInput {
  answer: string;
  answerId: string;
}

export interface UpdateCbCreditMatchInput {
  maxPromoPerRedemption: number;
}

export interface UpdateCbPromoCodeInput {
  creditMatch?: UpdateCbCreditMatchInput | null;
  expiresAt?: any | null;
  id: string;
  isActive?: boolean | null;
  note?: string | null;
  perAccountLimit?: number | null;
  startsAt?: any | null;
  subscription?: UpdateCbSubscriptionInput | null;
  totalUses?: number | null;
}

export interface UpdateCbSubscriptionInput {
  applicableTargets: CbPromoCodeTargetInput[];
  duration?: CbDiscountDuration | null;
  durationMonths?: number | null;
}

export interface UpdateChannelMonetizationProgramInput {
  prizeAmount?: number | null;
  prizeCurrency?: string | null;
  programId: string;
  slotsPerMonth?: number | null;
  status?: ChannelMonetizationProgramStatus | null;
}

export interface UpdateCustomCampaignInput {
  activities?: CustomBriefActivityInput[] | null;
  applicationDeadlineDays?: number | null;
  criteria?: SearchCustomCriteriaInput | null;
  expectedBudget?: number | null;
  id: string;
  internalName?: string | null;
  isPrivate?: boolean | null;
  lockEnabled?: boolean | null;
  name?: string | null;
  ownerId?: string | null;
  payout?: CampaignPayoutInput | null;
  questions?: CbApplicationQuestionInput[] | null;
  reservedBudget?: number | null;
  talentIds?: string[] | null;
  usageRights?: boolean | null;
  usageRightsDurationMonths?: number | null;
  usageRightsScopes?: CampaignUsageRightsScope[] | null;
  usageRightsText?: string | null;
}

export interface UpdateDirectBookingCampaignInput {
  activities?: CustomBriefActivityInput[] | null;
  flatFeePerStore?: number | null;
  id: string;
  internalName?: string | null;
  lockEnabled?: boolean | null;
  name?: string | null;
  ownerId?: string | null;
  talentId?: string | null;
  usageRights?: boolean | null;
  usageRightsDurationMonths?: number | null;
  usageRightsScopes?: CampaignUsageRightsScope[] | null;
  usageRightsText?: string | null;
}

export interface UpdateEventMarketingCampaignInput {
  activities?: EventMarketingCampaignActivityInput[] | null;
  id: string;
  lockEnabled?: boolean | null;
  name?: string | null;
  ownerId?: string | null;
}

export interface UpdateExperienceInput {
  comment?: string | null;
  description?: string | null;
  hashtagInputs?: HashtagInput[] | null;
  id: string;
  images: ExperienceImageInput[];
  numberOfUnits?: number | null;
  requestedPrice: number;
  title: string;
}

export interface UpdateInfluencerCategoryInput {
  id: number;
  name: string;
}

export interface UpdateInterviewInfoAdminInput {
  adminNotes?: string | null;
  chatEnabled?: boolean | null;
  hashtagInputs?: HashtagInput[] | null;
  id: string;
  imageFileKey?: string | null;
  mentionsInputs?: CreateMentionInput[] | null;
  name?: string | null;
  scheduledMeetingLink?: string | null;
  source?: InterviewSourceInput | null;
}

export interface UpdateInterviewInfoInput {
  hashtagInputs?: HashtagInput[] | null;
  id: string;
  imageFileKey?: string | null;
  mentionsInputs?: CreateMentionInput[] | null;
  name?: string | null;
  notes?: string | null;
  scheduledMeetingLink?: string | null;
}

export interface UpdateMemorabiliaInput {
  addressId?: string | null;
  auctionDateRange?: AuctionFromToInput | null;
  changedStock?: number | null;
  comment?: string | null;
  customsDescription?: string | null;
  description?: string | null;
  hashtagInputs?: HashtagInput[] | null;
  height?: number | null;
  id: string;
  images: MemorabiliaImageInput[];
  length?: number | null;
  requestedPrice: number;
  shipmentCategory: string;
  storeId: string;
  title: string;
  weight?: number | null;
  width?: number | null;
}

export interface UpdateMyCbSubscriptionInput {
  addressId?: string | null;
  items: SetMySubscriptionItemInput[];
  ownerId?: string | null;
  paymentMethodId: string;
  promoCode?: string | null;
}

export interface UpdateSocialBoostCampaignInput {
  activities?: SocialBoostActivityInput[] | null;
  criteria?: SearchSocialBoostCriteriaInput | null;
  id: string;
  internalName?: string | null;
  lockEnabled?: boolean | null;
  name?: string | null;
  ownerId?: string | null;
  startAt?: any | null;
  startMode?: CampaignStartMode | null;
}

export interface UpdateSocialShareCampaignInput {
  activities?: SocialShareActivityInput[] | null;
  applicationDeadlineDays?: number | null;
  applicationDeadlineEnabled?: boolean | null;
  criteria?: SearchSocialShareCriteriaInput | null;
  dueDate?: any | null;
  id: string;
  internalName?: string | null;
  lockEnabled?: boolean | null;
  name?: string | null;
  ownerId?: string | null;
  usageRights?: boolean | null;
  usageRightsText?: string | null;
}

export interface UpdateSponsoredAppearanceInput {
  activities?: SponsoredAppearanceActivityInput[] | null;
  applicationDeadlineDays?: number | null;
  applicationDeadlineEnabled?: boolean | null;
  criteria?: SearchSponsoredAppearanceCriteriaInput | null;
  dueDate?: any | null;
  id: string;
  internalName?: string | null;
  lockEnabled?: boolean | null;
  name?: string | null;
  ownerId?: string | null;
  questions?: CbApplicationQuestionInput[] | null;
  usageRights?: boolean | null;
  usageRightsText?: string | null;
}

export interface UpdateTicketEventDetailsInput {
  affiliateCommissionPercent?: number | null;
  affiliateEnabled?: boolean | null;
  coverImageFileKey?: string | null;
  description?: string | null;
  entryRequirements?: string | null;
  expectedVersion: number;
  fanPollingEnabled?: boolean | null;
  hashtagInputs?: HashtagInput[] | null;
  leagueId?: string | null;
  maxAdmissions?: number | null;
  minimumAge?: number | null;
  name?: string | null;
  promotion?: string | null;
  refundPolicy?: string | null;
  repeatsEvery?: StreamIntervalEnum | null;
  sportIds?: number[] | null;
  termsAndConditions?: string | null;
  ticketEventId: string;
  ticketsEnabled?: boolean | null;
  venueId?: string | null;
}

export interface UpdateTransitionInput {
  isActive?: boolean | null;
  name?: string | null;
}

export interface UpdateUgcCampaignInput {
  activities?: UgcActivityInput[] | null;
  applicationDeadlineDays?: number | null;
  applicationDeadlineEnabled?: boolean | null;
  criteria?: SearchUgcCriteriaInput | null;
  id: string;
  internalName?: string | null;
  lockEnabled?: boolean | null;
  name?: string | null;
  ownerId?: string | null;
  questions?: CbApplicationQuestionInput[] | null;
  usageRights?: boolean | null;
  usageRightsText?: string | null;
}

export interface UpdateUserRoleInput {
  email?: string | null;
  id?: string | null;
  newRole: UserRole;
  subtype?: AccountSubType | null;
}

export interface UpdateVideoEditInfoInput {
  adminNotes?: string | null;
  body?: string | null;
  dueDate?: any | null;
  hashtagInputs?: HashtagInput[] | null;
  id: string;
  mentionsInputs?: CreateMentionInput[] | null;
  notes?: string | null;
  status?: VideoEditRequestStatus | null;
  title?: string | null;
}

export interface UploadEditedVideo {
  body: string;
  durationMs?: number | null;
  hashtagInputs?: HashtagInput[] | null;
  id: string;
  mentionsInputs?: CreateMentionInput[] | null;
  thumbnailKey: string;
  title: string;
  video: CreateEditedVideoInput;
}

export interface UserDetailsInput {
  areaOfInfluenceIds?: string[] | null;
  email?: string | null;
  emailOtpVerificationId?: string | null;
  firstName?: string | null;
  hashtagIds?: number[] | null;
  hashtagInputs?: HashtagInput[] | null;
  influencerCategoryIds?: number[] | null;
  isForBrandDealsOnly?: boolean | null;
  isOrphanPage?: boolean | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  phoneNumberE164?: string | null;
  phoneOptIn?: boolean | null;
  phoneOtpVerificationId?: string | null;
  psychosocialKeywordsIds?: string[] | null;
  redirects?: string[] | null;
  sportIds?: number[] | null;
  username?: string | null;
}

export interface UserFeatureLimitsListInput {
  direction?: SortDirection | null;
  featureKey?: FeatureLimitKey | null;
  limit?: number | null;
  offset?: number | null;
  searchTerm?: string | null;
}

export interface UserPayoutInput {
  amount: number;
  userId: string;
}

export interface UserUpdateInput {
  avatarKey?: string | null;
  email?: string | null;
  emailOtpVerificationId?: string | null;
  firstName?: string | null;
  id?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  phoneNumberE164?: string | null;
  phoneOptIn?: boolean | null;
  phoneOtpVerificationId?: string | null;
  username?: string | null;
}

export interface UsersFilterInput {
  direction?: SortDirection | null;
  email?: string | null;
  emails?: string[] | null;
  facebookLink?: string | null;
  firstName?: string | null;
  hasAma?: boolean | null;
  hasMerch?: boolean | null;
  hasStream?: boolean | null;
  id?: string | null;
  instagramLink?: string | null;
  isDeleteRequested?: boolean | null;
  isOnboarded?: boolean | null;
  lastName?: string | null;
  limit?: number | null;
  name?: string | null;
  offset?: number | null;
  orderBy?: UsersOrderFields | null;
  phoneNumber?: number | null;
  role?: UserRole | null;
  slug?: string | null;
  socialMediaLink?: string | null;
  sportId?: number | null;
  status?: StoreStatus[] | null;
  tiktokLink?: string | null;
  twitterLink?: string | null;
  types?: AccountType[] | null;
}

export interface VariantEstimatePrintFileInput {
  placementType: PlacementTypes;
}

export interface VariantPrintFileInput {
  key: string;
  placementType: PlacementTypes;
  printFilePlacements: ProductPrintFilePlacementInput[];
}

export interface VariantPrintfilePresignedUrlInput {
  contentType: string;
  ext: string;
}

export interface VideoCroppedArea {
  height: number;
  width: number;
  x: number;
  y: number;
  zoom: number;
}

export interface VideoCroppedInput {
  area?: VideoCroppedArea | null;
  file: any;
  type?: string | null;
}

export interface VideoEditRequestAction {
  feedback?: string | null;
  videoEditRequestId: string;
  videoEditorId?: string | null;
}

export interface VideoEditRequestAdminInput {
  additionalStoreIds?: string[] | null;
  adminNotes?: string | null;
  dueDate?: any | null;
  hashtagInputs?: HashtagInput[] | null;
  mentionsInputs?: CreateMentionInput[] | null;
  rawUrls: string[];
  storeId: string;
  videoEditorId: string;
}

export interface VideoEditRequestBooleanTriggerSettingInput {
  isEnabled: boolean;
}

export interface VideoEditRequestTriggerSettingConfigInput {
  duration: number;
}

export interface VideoEditRequestTriggerSettingInput {
  config: VideoEditRequestTriggerSettingConfigInput;
  isEnabled: boolean;
}

export interface VideoEditRequestsFilterInput {
  direction?: SortDirection | null;
  isOverdue?: boolean | null;
  isUnassigned?: boolean | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: VideoEditRequestsOrderBy | null;
  storeIds?: string[] | null;
  storeName?: string | null;
  videoEditRequestId?: string | null;
  videoEditRequestStatuses?: VideoEditRequestStatus[] | null;
  videoEditorIds?: string[] | null;
  videoEditorName?: string | null;
}

export interface VideoEditorCreateInput {
  email: string;
  firstName: string;
  lastName: string;
}

export interface VideoEditorDetailsEditInput {
  isIncludedInAutoAssignment?: boolean | null;
}

export interface VideoEditorEditInput {
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  password?: string | null;
  phoneNumber?: string | null;
  socialMediaLink?: string | null;
  videoEditorDetails?: VideoEditorDetailsEditInput | null;
  videoEditorId?: string | null;
}

export interface VideoEditorFilterInput {
  direction?: SortDirection | null;
  email?: string | null;
  hasActiveVideoEditRequests?: boolean | null;
  limit: number;
  offset: number;
  orderBy: VideoEditorOrderBy;
  videoEditorIds?: string[] | null;
  videoEditorName?: string | null;
  videoEditorStatus?: StoreStatus[] | null;
}

export interface VirtualAppearanceActivityInput {
  description?: string | null;
  duration?: string | null;
  files?: CampaignExampleFileInput[] | null;
  instructions?: string | null;
  location?: string | null;
  possibleDates?: any[] | null;
}

export interface VoidCancelCbSubscriptionInput {
  ownerId?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
